export var CardName;
(function (CardName) {
    // Standard projects:
    CardName["SELL_PATENTS_STANDARD_PROJECT"] = "Sell Patents";
    CardName["POWER_PLANT_STANDARD_PROJECT"] = "Power Plant:SP";
    CardName["ASTEROID_STANDARD_PROJECT"] = "Asteroid:SP";
    CardName["BUFFER_GAS_STANDARD_PROJECT"] = "Buffer Gas";
    CardName["BUILD_COLONY_STANDARD_PROJECT"] = "Build Colony";
    CardName["AQUIFER_STANDARD_PROJECT"] = "Aquifer";
    CardName["GREENERY_STANDARD_PROJECT"] = "Greenery";
    CardName["CITY_STANDARD_PROJECT"] = "City";
    CardName["AIR_SCRAPPING_STANDARD_PROJECT"] = "Air Scrapping";
    CardName["AIR_SCRAPPING_STANDARD_PROJECT_VARIANT"] = "Air Scrapping (Var)";
    // Standard actions:
    CardName["CONVERT_PLANTS"] = "Convert Plants";
    CardName["CONVERT_HEAT"] = "Convert Heat";
    // Conglomerates team actions:
    CardName["GIVE_PATENT"] = "Give Patent";
    CardName["FACILITY_SHARING"] = "Facility Access";
    CardName["TEAM_DONATION"] = "Finance";
    // Conglomerates cards:
    CardName["SELFISH"] = "Selfish";
    CardName["FULL_ACCESS_COOPERATION"] = "Full Access Cooperation";
    CardName["HELP_REQUEST"] = "Help Request";
    CardName["ACQUIRED_COMPANY"] = "Acquired Company";
    CardName["ADAPTATION_TECHNOLOGY"] = "Adaptation Technology";
    CardName["ADAPTED_LICHEN"] = "Adapted Lichen";
    CardName["ADVANCED_ALLOYS"] = "Advanced Alloys";
    CardName["ADVANCED_ECOSYSTEMS"] = "Advanced Ecosystems";
    CardName["AEROBRAKED_AMMONIA_ASTEROID"] = "Aerobraked Ammonia Asteroid";
    CardName["AI_CENTRAL"] = "AI Central";
    CardName["AIR_RAID"] = "Air Raid";
    CardName["AIRLINERS"] = "Airliners";
    CardName["ALGAE"] = "Algae";
    CardName["ANTI_GRAVITY_TECHNOLOGY"] = "Anti-Gravity Technology";
    CardName["ANTS"] = "Ants";
    CardName["AQUIFER_PUMPING"] = "Aquifer Pumping";
    CardName["AQUIFER_TURBINES"] = "Aquifer Turbines";
    CardName["ARCHAEBACTERIA"] = "ArchaeBacteria";
    CardName["ARTIFICIAL_LAKE"] = "Artificial Lake";
    CardName["ARTIFICIAL_PHOTOSYNTHESIS"] = "Artificial Photosynthesis";
    CardName["ARCTIC_ALGAE"] = "Arctic Algae";
    CardName["ASTEROID"] = "Asteroid";
    CardName["ASTEROID_MINING"] = "Asteroid Mining";
    CardName["ASTEROID_MINING_CONSORTIUM"] = "Asteroid Mining Consortium";
    CardName["ATMO_COLLECTORS"] = "Atmo Collectors";
    CardName["BREATHING_FILTERS"] = "Breathing Filters";
    CardName["BRIBED_COMMITTEE"] = "Bribed Committee";
    CardName["BEAM_FROM_A_THORIUM_ASTEROID"] = "Beam From A Thorium Asteroid";
    CardName["BIG_ASTEROID"] = "Big Asteroid";
    CardName["BIOMASS_COMBUSTORS"] = "Biomass Combustors";
    CardName["BIRDS"] = "Birds";
    CardName["BLACK_POLAR_DUST"] = "Black Polar Dust";
    CardName["BUILDING_INDUSTRIES"] = "Building Industries";
    CardName["BUSHES"] = "Bushes";
    CardName["BUSINESS_CONTACTS"] = "Business Contacts";
    CardName["BUSINESS_NETWORK"] = "Business Network";
    CardName["CALLISTO_PENAL_MINES"] = "Callisto Penal Mines";
    CardName["CARBONATE_PROCESSING"] = "Carbonate Processing";
    CardName["CAPITAL"] = "Capital";
    CardName["CARETAKER_CONTRACT"] = "Caretaker Contract";
    CardName["CARTEL"] = "Cartel";
    CardName["CEOS_FAVORITE_PROJECT"] = "CEO's Favorite Project";
    CardName["CLOUD_SEEDING"] = "Cloud Seeding";
    CardName["COLONIZER_TRAINING_CAMP"] = "Colonizer Training Camp";
    CardName["COMET"] = "Comet";
    CardName["COMMERCIAL_DISTRICT"] = "Commercial District";
    CardName["COMMUNITY_SERVICES"] = "Community Services";
    CardName["CONSCRIPTION"] = "Conscription";
    CardName["CONVOY_FROM_EUROPA"] = "Convoy From Europa";
    CardName["CORONA_EXTRACTOR"] = "Corona Extractor";
    CardName["CORPORATE_STRONGHOLD"] = "Corporate Stronghold";
    CardName["CRYO_SLEEP"] = "Cryo-Sleep";
    CardName["CUPOLA_CITY"] = "Cupola City";
    CardName["DECOMPOSERS"] = "Decomposers";
    CardName["DEEP_WELL_HEATING"] = "Deep Well Heating";
    CardName["DEIMOS_DOWN"] = "Deimos Down";
    CardName["DESIGNED_MICROORGANISMS"] = "Designed Microorganisms";
    CardName["DEVELOPMENT_CENTER"] = "Development Center";
    CardName["DIRIGIBLES"] = "Dirigibles";
    CardName["DOME_FARMING"] = "Dome Farming";
    CardName["DOMED_CRATER"] = "Domed Crater";
    CardName["DUST_SEALS"] = "Dust Seals";
    CardName["EARLY_SETTLEMENT"] = "Early Settlement";
    CardName["EARTH_CATAPULT"] = "Earth Catapult";
    CardName["EARTH_ELEVATOR"] = "Earth Elevator";
    CardName["EARTH_OFFICE"] = "Earth Office";
    CardName["ECCENTRIC_SPONSOR"] = "Eccentric Sponsor";
    CardName["ECOLOGICAL_ZONE"] = "Ecological Zone";
    CardName["ECOLOGY_EXPERTS"] = "Ecology Experts";
    CardName["ECOLOGY_RESEARCH"] = "Ecology Research";
    CardName["ELECTRO_CATAPULT"] = "Electro Catapult";
    CardName["ENERGY_SAVING"] = "Energy Saving";
    CardName["ENERGY_TAPPING"] = "Energy Tapping";
    CardName["EOS_CHASMA_NATIONAL_PARK"] = "Eos Chasma National Park";
    CardName["EQUATORIAL_MAGNETIZER"] = "Equatorial Magnetizer";
    CardName["EXTREME_COLD_FUNGUS"] = "Extreme-Cold Fungus";
    CardName["FARMING"] = "Farming";
    CardName["FISH"] = "Fish";
    CardName["FLOATER_LEASING"] = "Floater Leasing";
    CardName["FLOATER_PROTOTYPES"] = "Floater Prototypes";
    CardName["FLOATER_TECHNOLOGY"] = "Floater Technology";
    CardName["FLOODING"] = "Flooding";
    CardName["FOOD_FACTORY"] = "Food Factory";
    CardName["FUEL_FACTORY"] = "Fuel Factory";
    CardName["FUELED_GENERATORS"] = "Fueled Generators";
    CardName["FUSION_POWER"] = "Fusion Power";
    CardName["GALILEAN_WAYSTATION"] = "Galilean Waystation";
    CardName["GANYMEDE_COLONY"] = "Ganymede Colony";
    CardName["GENE_REPAIR"] = "Gene Repair";
    CardName["GEOTHERMAL_POWER"] = "Geothermal Power";
    CardName["GHG_PRODUCING_BACTERIA"] = "GHG Producing Bacteria";
    CardName["GHG_FACTORIES"] = "GHG Factories";
    CardName["GIANT_ICE_ASTEROID"] = "Giant Ice Asteroid";
    CardName["GIANT_SPACE_MIRROR"] = "Giant Space Mirror";
    CardName["GRASS"] = "Grass";
    CardName["GREAT_AQUIFER"] = "Great Aquifer";
    CardName["GREAT_DAM"] = "Great Dam";
    CardName["GREAT_ESCARPMENT_CONSORTIUM"] = "Great Escarpment Consortium";
    CardName["GREENHOUSES"] = "Greenhouses";
    CardName["GYROPOLIS"] = "Gyropolis";
    CardName["HACKERS"] = "Hackers";
    CardName["HEATHER"] = "Heather";
    CardName["HEAT_TRAPPERS"] = "Heat Trappers";
    CardName["HEAVY_TAXATION"] = "Heavy Taxation";
    CardName["HERBIVORES"] = "Herbivores";
    CardName["HIRED_RAIDERS"] = "Hired Raiders";
    CardName["HOUSE_PRINTING"] = "House Printing";
    CardName["ICE_ASTEROID"] = "Ice Asteroid";
    CardName["ICE_CAP_MELTING"] = "Ice Cap Melting";
    CardName["ICE_MOON_COLONY"] = "Ice Moon Colony";
    CardName["IMMIGRANT_CITY"] = "Immigrant City";
    CardName["IMMIGRATION_SHUTTLES"] = "Immigration Shuttles";
    CardName["IMPACTOR_SWARM"] = "Impactor Swarm";
    CardName["IMPORTED_GHG"] = "Imported GHG";
    CardName["IMPORTED_HYDROGEN"] = "Imported Hydrogen";
    CardName["IMPORTED_NITROGEN"] = "Imported Nitrogen";
    CardName["IMPORT_OF_ADVANCED_GHG"] = "Import of Advanced GHG";
    CardName["INDENTURED_WORKERS"] = "Indentured Workers";
    CardName["INDUSTRIAL_MICROBES"] = "Industrial Microbes";
    CardName["INSECTS"] = "Insects";
    CardName["INSULATION"] = "Insulation";
    CardName["INTERPLANETARY_COLONY_SHIP"] = "Interplanetary Colony Ship";
    CardName["INTERSTELLAR_COLONY_SHIP"] = "Interstellar Colony Ship";
    CardName["INVENTION_CONTEST"] = "Invention Contest";
    CardName["INVENTORS_GUILD"] = "Inventors' Guild";
    CardName["INVESTMENT_LOAN"] = "Investment Loan";
    CardName["IO_MINING_INDUSTRIES"] = "Io Mining Industries";
    CardName["IRONWORKS"] = "Ironworks";
    CardName["JOVIAN_LANTERNS"] = "Jovian Lanterns";
    CardName["JUPITER_FLOATING_STATION"] = "Jupiter Floating Station";
    CardName["KELP_FARMING"] = "Kelp Farming";
    CardName["LAGRANGE_OBSERVATORY"] = "Lagrange Observatory";
    CardName["LAKE_MARINERIS"] = "Lake Marineris";
    CardName["LAND_CLAIM"] = "Land Claim";
    CardName["LARGE_CONVOY"] = "Large Convoy";
    CardName["LAVA_FLOWS"] = "Lava Flows";
    CardName["LAVA_TUBE_SETTLEMENT"] = "Lava Tube Settlement";
    CardName["LICHEN"] = "Lichen";
    CardName["LIGHTNING_HARVEST"] = "Lightning Harvest";
    CardName["LIVESTOCK"] = "Livestock";
    CardName["LOCAL_HEAT_TRAPPING"] = "Local Heat Trapping";
    CardName["LUNAR_BEAM"] = "Lunar Beam";
    CardName["LUNA_GOVERNOR"] = "Luna Governor";
    CardName["LUNAR_EXPORTS"] = "Lunar Exports";
    CardName["LUNAR_MINING"] = "Lunar Mining";
    CardName["MAGNETIC_FIELD_DOME"] = "Magnetic Field Dome";
    CardName["MAGNETIC_FIELD_GENERATORS"] = "Magnetic Field Generators";
    CardName["MARKET_MANIPULATION"] = "Market Manipulation";
    CardName["MARTIAN_INDUSTRIES"] = "Martian Industries";
    CardName["MARTIAN_ZOO"] = "Martian Zoo";
    CardName["MANGROVE"] = "Mangrove";
    CardName["MARS_UNIVERSITY"] = "Mars University";
    CardName["MARTIAN_RAILS"] = "Martian Rails";
    CardName["MASS_CONVERTER"] = "Mass Converter";
    CardName["MEDIA_ARCHIVES"] = "Media Archives";
    CardName["MEDIA_GROUP"] = "Media Group";
    CardName["MEDICAL_LAB"] = "Medical Lab";
    CardName["METHANE_FROM_TITAN"] = "Methane From Titan";
    CardName["MICRO_MILLS"] = "Micro-Mills";
    CardName["MINE"] = "Mine";
    CardName["MINERAL_DEPOSIT"] = "Mineral Deposit";
    CardName["MIRANDA_RESORT"] = "Miranda Resort";
    CardName["MINING_AREA"] = "Mining Area";
    CardName["MINING_COLONY"] = "Mining Colony";
    CardName["MINING_EXPEDITION"] = "Mining Expedition";
    CardName["MINING_OPERATIONS"] = "Mining Operations";
    CardName["MINING_QUOTA"] = "Mining Quota";
    CardName["MINING_RIGHTS"] = "Mining Rights";
    CardName["MINORITY_REFUGE"] = "Minority Refuge";
    CardName["MOHOLE"] = "Mohole";
    CardName["MOHOLE_AREA"] = "Mohole Area";
    CardName["MOHOLE_EXCAVATION"] = "Mohole Excavation";
    CardName["MOLECULAR_PRINTING"] = "Molecular Printing";
    CardName["MOSS"] = "Moss";
    CardName["NATURAL_PRESERVE"] = "Natural Preserve";
    CardName["NITRITE_REDUCING_BACTERIA"] = "Nitrite Reducing Bacteria";
    CardName["NITROGEN_RICH_ASTEROID"] = "Nitrogen-Rich Asteroid";
    CardName["NITROGEN_FROM_TITAN"] = "Nitrogen from Titan";
    CardName["NITROPHILIC_MOSS"] = "Nitrophilic Moss";
    CardName["NOCTIS_CITY"] = "Noctis City";
    CardName["NOCTIS_FARMING"] = "Noctis Farming";
    CardName["NUCLEAR_POWER"] = "Nuclear Power";
    CardName["NUCLEAR_ZONE"] = "Nuclear Zone";
    CardName["OLYMPUS_CONFERENCE"] = "Olympus Conference";
    CardName["OMNICOURT"] = "Omnicourt";
    CardName["OPEN_CITY"] = "Open City";
    CardName["OPTIMAL_AEROBRAKING"] = "Optimal Aerobraking";
    CardName["ORE_PROCESSOR"] = "Ore Processor";
    CardName["PERMAFROST_EXTRACTION"] = "Permafrost Extraction";
    CardName["PEROXIDE_POWER"] = "Peroxide Power";
    CardName["PETS"] = "Pets";
    CardName["PHOBOS_SPACE_HAVEN"] = "Phobos Space Haven";
    CardName["PHYSICS_COMPLEX"] = "Physics Complex";
    CardName["PIONEER_SETTLEMENT"] = "Pioneer Settlement";
    CardName["PLANTATION"] = "Plantation";
    CardName["POLAR_INDUSTRIES"] = "Polar Industries";
    CardName["POWER_GRID"] = "Power Grid";
    CardName["POWER_INFRASTRUCTURE"] = "Power Infrastructure";
    CardName["POWER_PLANT"] = "Power Plant";
    CardName["POWER_SUPPLY_CONSORTIUM"] = "Power Supply Consortium";
    CardName["PREDATORS"] = "Predators";
    CardName["PRODUCTIVE_OUTPOST"] = "Productive Outpost";
    CardName["PROTECTED_HABITATS"] = "Protected Habitats";
    CardName["PROTECTED_VALLEY"] = "Protected Valley";
    CardName["PSYCHROPHILES"] = "Psychrophiles";
    CardName["QUANTUM_COMMUNICATIONS"] = "Quantum Communications";
    CardName["QUANTUM_EXTRACTOR"] = "Quantum Extractor";
    CardName["RAD_CHEM_FACTORY"] = "Rad-Chem Factory";
    CardName["RAD_SUITS"] = "Rad-Suits";
    CardName["RED_SPOT_OBSERVATORY"] = "Red Spot Observatory";
    CardName["REFUGEE_CAMPS"] = "Refugee Camps";
    CardName["REGOLITH_EATERS"] = "Regolith Eaters";
    CardName["RELEASE_OF_INERT_GASES"] = "Release of Inert Gases";
    CardName["RESEARCH"] = "Research";
    CardName["RESEARCH_OUTPOST"] = "Research Outpost";
    CardName["RESEARCH_COLONY"] = "Research Colony";
    CardName["RESTRICTED_AREA"] = "Restricted Area";
    CardName["ROBOTIC_WORKFORCE"] = "Robotic Workforce";
    CardName["ROVER_CONSTRUCTION"] = "Rover Construction";
    CardName["RIM_FREIGHTERS"] = "Rim Freighters";
    CardName["SABOTAGE"] = "Sabotage";
    CardName["SATELLITES"] = "Satellites";
    CardName["SEARCH_FOR_LIFE"] = "Search For Life";
    CardName["SECURITY_FLEET"] = "Security Fleet";
    CardName["SELF_SUFFICIENT_SETTLEMENT"] = "Self-Sufficient Settlement";
    CardName["SISTER_PLANET_SUPPORT"] = "Sister Planet Support";
    CardName["SKY_DOCKS"] = "Sky Docks";
    CardName["SMALL_ANIMALS"] = "Small Animals";
    CardName["SOIL_FACTORY"] = "Soil Factory";
    CardName["SOLAR_POWER"] = "Solar Power";
    CardName["SOLAR_PROBE"] = "Solar Probe";
    CardName["SOLAR_REFLECTORS"] = "Solar Reflectors";
    CardName["SOLARNET"] = "Solarnet";
    CardName["SPACE_ELEVATOR"] = "Space Elevator";
    CardName["SPACE_PORT"] = "Space Port";
    CardName["SPACE_PORT_COLONY"] = "Space Port Colony";
    CardName["SPINOFF_DEPARTMENT"] = "Spin-off Department";
    CardName["STRIP_MINE"] = "Strip Mine";
    CardName["SUBTERRANEAN_RESERVOIR"] = "Subterranean Reservoir";
    CardName["SUBZERO_SALT_FISH"] = "Sub-zero Salt Fish";
    CardName["SHUTTLES"] = "Shuttles";
    CardName["SOLAR_WIND_POWER"] = "Solar Wind Power";
    CardName["SOLETTA"] = "Soletta";
    CardName["SPACE_MIRRORS"] = "Space Mirrors";
    CardName["SPACE_STATION"] = "Space Station";
    CardName["SPECIAL_DESIGN"] = "Special Design";
    CardName["SPONSORS"] = "Sponsors";
    CardName["STEELWORKS"] = "Steelworks";
    CardName["STANDARD_TECHNOLOGY"] = "Standard Technology";
    CardName["SYMBIOTIC_FUNGUS"] = "Symbiotic Fungus";
    CardName["TARDIGRADES"] = "Tardigrades";
    CardName["TECHNOLOGY_DEMONSTRATION"] = "Technology Demonstration";
    CardName["TECTONIC_STRESS_POWER"] = "Tectonic Stress Power";
    CardName["TERRAFORMING_GANYMEDE"] = "Terraforming Ganymede";
    CardName["TITAN_AIRSCRAPPING"] = "Titan Air-scrapping";
    CardName["TITAN_FLOATING_LAUNCHPAD"] = "Titan Floating Launch-pad";
    CardName["TITAN_SHUTTLES"] = "Titan Shuttles";
    CardName["TITANIUM_MINE"] = "Titanium Mine";
    CardName["TOLL_STATION"] = "Toll Station";
    CardName["TOWING_A_COMET"] = "Towing A Comet";
    CardName["TRADE_ENVOYS"] = "Trade Envoys";
    CardName["TRADING_COLONY"] = "Trading Colony";
    CardName["TRANS_NEPTUNE_PROBE"] = "Trans-Neptune Probe";
    CardName["TREES"] = "Trees";
    CardName["TROPICAL_RESORT"] = "Tropical Resort";
    CardName["TUNDRA_FARMING"] = "Tundra Farming";
    CardName["UNDERGROUND_CITY"] = "Underground City";
    CardName["UNDERGROUND_DETONATIONS"] = "Underground Detonations";
    CardName["URBAN_DECOMPOSERS"] = "Urban Decomposers";
    CardName["URBANIZED_AREA"] = "Urbanized Area";
    CardName["VESTA_SHIPYARD"] = "Vesta Shipyard";
    CardName["VIRAL_ENHANCERS"] = "Viral Enhancers";
    CardName["VIRUS"] = "Virus";
    CardName["WARP_DRIVE"] = "Warp Drive";
    CardName["WATER_IMPORT_FROM_EUROPA"] = "Water Import From Europa";
    // Venus:
    CardName["AERIAL_MAPPERS"] = "Aerial Mappers";
    CardName["AEROSPORT_TOURNAMENT"] = "Aerosport Tournament";
    CardName["AIR_SCRAPPING_EXPEDITION"] = "Air-Scrapping Expedition";
    CardName["APHRODITE"] = "Aphrodite";
    CardName["ATALANTA_PLANITIA_LAB"] = "Atalanta Planitia Lab";
    CardName["ATMOSCOOP"] = "Atmoscoop";
    CardName["CELESTIC"] = "Celestic";
    CardName["COMET_FOR_VENUS"] = "Comet for Venus";
    CardName["CORRODER_SUITS"] = "Corroder Suits";
    CardName["DAWN_CITY"] = "Dawn City";
    CardName["DEUTERIUM_EXPORT"] = "Deuterium Export";
    CardName["EXTRACTOR_BALLOONS"] = "Extractor Balloons";
    CardName["EXTREMOPHILES"] = "Extremophiles";
    CardName["FLOATING_HABS"] = "Floating Habs";
    CardName["FORCED_PRECIPITATION"] = "Forced Precipitation";
    CardName["FREYJA_BIODOMES"] = "Freyja Biodomes";
    CardName["GHG_IMPORT_FROM_VENUS"] = "GHG Import From Venus";
    CardName["GIANT_SOLAR_SHADE"] = "Giant Solar Shade";
    CardName["HYDROGEN_TO_VENUS"] = "Hydrogen to Venus";
    CardName["IO_SULPHUR_RESEARCH"] = "Io Sulphur Research";
    CardName["ISHTAR_MINING"] = "Ishtar Mining";
    CardName["JET_STREAM_MICROSCRAPPERS"] = "Jet Stream Microscrappers";
    CardName["LOCAL_SHADING"] = "Local Shading";
    CardName["LUNA_METROPOLIS"] = "Luna Metropolis";
    CardName["LUXURY_FOODS"] = "Luxury Foods";
    CardName["MAXWELL_BASE"] = "Maxwell Base";
    CardName["MORNING_STAR_INC"] = "Morning Star Inc.";
    CardName["NEUTRALIZER_FACTORY"] = "Neutralizer Factory";
    CardName["ORBITAL_REFLECTORS"] = "Orbital Reflectors";
    CardName["ROTATOR_IMPACTS"] = "Rotator Impacts";
    CardName["SPIN_INDUCING_ASTEROID"] = "Spin-Inducing Asteroid";
    CardName["SPONSORED_ACADEMIES"] = "Sponsored Academies";
    CardName["STRATOPOLIS"] = "Stratopolis";
    CardName["STRATOSPHERIC_BIRDS"] = "Stratospheric Birds";
    CardName["SULPHUR_EATING_BACTERIA"] = "Sulphur-Eating Bacteria";
    CardName["SULPHUR_EXPORTS"] = "Sulphur Exports";
    CardName["TERRAFORMING_CONTRACT"] = "Terraforming Contract";
    CardName["THERMOPHILES"] = "Thermophiles";
    CardName["VENUS_GOVERNOR"] = "Venus Governor";
    CardName["VENUSIAN_ANIMALS"] = "Venusian Animals";
    CardName["VENUSIAN_INSECTS"] = "Venusian Insects";
    CardName["VENUSIAN_PLANTS"] = "Venusian Plants";
    CardName["VENUS_MAGNETIZER"] = "Venus Magnetizer";
    CardName["VENUS_SOILS"] = "Venus Soils";
    CardName["VENUS_WAYSTATION"] = "Venus Waystation";
    CardName["VIRON"] = "Viron";
    CardName["WATER_TO_VENUS"] = "Water to Venus";
    CardName["WATER_SPLITTING_PLANT"] = "Water Splitting Plant";
    CardName["WAVE_POWER"] = "Wave Power";
    CardName["WINDMILLS"] = "Windmills";
    CardName["WORMS"] = "Worms";
    CardName["ZEPPELINS"] = "Zeppelins";
    // Corps:
    CardName["BEGINNER_CORPORATION"] = "Beginner Corporation";
    CardName["CREDICOR"] = "CrediCor";
    CardName["ECOLINE"] = "Ecoline";
    CardName["HELION"] = "Helion";
    CardName["INTERPLANETARY_CINEMATICS"] = "Interplanetary Cinematics";
    CardName["INVENTRIX"] = "Inventrix";
    CardName["MINING_GUILD"] = "Mining Guild";
    CardName["PHOBOLOG"] = "PhoboLog";
    CardName["SATURN_SYSTEMS"] = "Saturn Systems";
    CardName["TERACTOR"] = "Teractor";
    CardName["THARSIS_REPUBLIC"] = "Tharsis Republic";
    CardName["THORGATE"] = "ThorGate";
    CardName["UNITED_NATIONS_MARS_INITIATIVE"] = "United Nations Mars Initiative";
    CardName["ACQUIRED_SPACE_AGENCY"] = "Acquired Space Agency";
    // Preludes:
    CardName["ALLIED_BANK"] = "Allied Bank";
    CardName["BIOFUELS"] = "Biofuels";
    CardName["BIOLAB"] = "Biolab";
    CardName["BIOSPHERE_SUPPORT"] = "Biosphere Support";
    CardName["BUSINESS_EMPIRE"] = "Business Empire";
    CardName["CHEUNG_SHING_MARS"] = "Cheung Shing MARS";
    CardName["DONATION"] = "Donation";
    CardName["EXPERIMENTAL_FOREST"] = "Experimental Forest";
    CardName["GALILEAN_MINING"] = "Galilean Mining";
    CardName["HUGE_ASTEROID"] = "Huge Asteroid";
    CardName["IO_RESEARCH_OUTPOST"] = "Io Research Outpost";
    CardName["LOAN"] = "Loan";
    CardName["MARTIAN_SURVEY"] = "Martian Survey";
    CardName["METAL_RICH_ASTEROID"] = "Metal-Rich Asteroid";
    CardName["METALS_COMPANY"] = "Metals Company";
    CardName["NITROGEN_SHIPMENT"] = "Nitrogen Shipment";
    CardName["ORBITAL_CONSTRUCTION_YARD"] = "Orbital Construction Yard";
    CardName["POINT_LUNA"] = "Point Luna";
    CardName["POWER_GENERATION"] = "Power Generation";
    CardName["RESEARCH_COORDINATION"] = "Research Coordination";
    CardName["RESEARCH_NETWORK"] = "Research Network";
    CardName["ROBINSON_INDUSTRIES"] = "Robinson Industries";
    CardName["SF_MEMORIAL"] = "SF Memorial";
    CardName["SMELTING_PLANT"] = "Smelting Plant";
    CardName["SOCIETY_SUPPORT"] = "Society Support";
    CardName["SPACE_HOTELS"] = "Space Hotels";
    CardName["SUPPLIER"] = "Supplier";
    CardName["SUPPLY_DROP"] = "Supply Drop";
    CardName["UNMI_CONTRACTOR"] = "UNMI Contractor";
    CardName["VALLEY_TRUST"] = "Valley Trust";
    CardName["VITOR"] = "Vitor";
    CardName["ARIDOR"] = "Aridor";
    CardName["ARKLIGHT"] = "Arklight";
    CardName["POSEIDON"] = "Poseidon";
    CardName["STORMCRAFT_INCORPORATED"] = "Stormcraft Incorporated";
    CardName["ARCADIAN_COMMUNITIES"] = "Arcadian Communities";
    CardName["ASTRODRILL"] = "AstroDrill";
    CardName["ADVERTISING"] = "Advertising";
    CardName["PHARMACY_UNION"] = "Pharmacy Union";
    CardName["INDUSTRIAL_CENTER"] = "Industrial Center";
    CardName["FACTORUM"] = "Factorum";
    CardName["LAKEFRONT_RESORTS"] = "Lakefront Resorts";
    CardName["TERRALABS_RESEARCH"] = "TerraLabs Research";
    CardName["SEPTUM_TRIBUS"] = "Septem Tribus";
    CardName["MONS_INSURANCE"] = "Mons Insurance";
    CardName["SPLICE"] = "Splice";
    CardName["PHILARES"] = "Philares";
    CardName["PRISTAR"] = "Pristar";
    CardName["RECYCLON"] = "Recyclon";
    CardName["UTOPIA_INVEST"] = "Utopia Invest";
    CardName["MANUTECH"] = "Manutech";
    CardName["SELF_REPLICATING_ROBOTS"] = "Self-replicating Robots";
    CardName["POLYPHEMOS"] = "Polyphemos";
    CardName["PENGUINS"] = "Penguins";
    CardName["SMALL_ASTEROID"] = "Small Asteroid";
    CardName["SNOW_ALGAE"] = "Snow Algae";
    CardName["AERIAL_LENSES"] = "Aerial Lenses";
    CardName["BANNED_DELEGATE"] = "Banned Delegate";
    CardName["CULTURAL_METROPOLIS"] = "Cultural Metropolis";
    CardName["DIASPORA_MOVEMENT"] = "Diaspora Movement";
    CardName["EVENT_ANALYSTS"] = "Event Analysts";
    CardName["GMO_CONTRACT"] = "GMO Contract";
    CardName["MARTIAN_MEDIA_CENTER"] = "Martian Media Center";
    CardName["PARLIAMENT_HALL"] = "Parliament Hall";
    CardName["PR_OFFICE"] = "PR Office";
    CardName["PUBLIC_CELEBRATIONS"] = "Public Celebrations";
    CardName["RECRUITMENT"] = "Recruitment";
    CardName["RED_TOURISM_WAVE"] = "Red Tourism Wave";
    CardName["SPONSORED_MOHOLE"] = "Sponsored Mohole";
    CardName["SUPPORTED_RESEARCH"] = "Supported Research";
    CardName["WILDLIFE_DOME"] = "Wildlife Dome";
    CardName["VOTE_OF_NO_CONFIDENCE"] = "Vote Of No Confidence";
    // Prelude 2
    // Prelude 2 Project Cards
    CardName["CERES_TECH_MARKET"] = "Ceres Tech Market";
    CardName["CLOUD_TOURISM"] = "Cloud Tourism";
    CardName["COLONIAL_ENVOYS"] = "Colonial Envoys";
    CardName["COLONIAL_REPRESENTATION"] = "Colonial Representation";
    CardName["ENVOYS_FROM_VENUS"] = "Envoys From Venus";
    CardName["FLOATING_REFINERY"] = "Floating Refinery";
    CardName["FRONTIER_TOWN"] = "Frontier Town";
    CardName["GHG_SHIPMENT"] = "GHG Shipment";
    CardName["ISHTAR_EXPEDITION"] = "Ishtar Expedition";
    CardName["JOVIAN_ENVOYS"] = "Jovian Envoys";
    CardName["L1_TRADE_TERMINAL"] = "L1 Trade Terminal";
    CardName["MICROGRAVITY_NUTRITION"] = "Microgravity Nutrition";
    CardName["RED_APPEASEMENT"] = "Red Appeasement";
    CardName["SOIL_STUDIES"] = "Soil Studies";
    CardName["SPECIAL_PERMIT"] = "Special Permit";
    CardName["SPONSORING_NATION"] = "Sponsoring Nation";
    CardName["STRATOSPHERIC_EXPEDITION"] = "Stratospheric Expedition";
    CardName["SUMMIT_LOGISTICS"] = "Summit Logistics";
    CardName["UNEXPECTED_APPLICATION"] = "Unexpected Application";
    CardName["VENUS_ALLIES"] = "Venus Allies";
    CardName["VENUS_ORBITAL_SURVEY"] = "Venus Orbital Survey";
    CardName["VENUS_SHUTTLES"] = "Venus Shuttles";
    CardName["VENUS_TRADE_HUB"] = "Venus Trade Hub";
    CardName["WG_PROJECT"] = "WG Project";
    // Prelude 2 Preludes
    CardName["APPLIED_SCIENCE"] = "Applied Science";
    CardName["ATMOSPHERIC_ENHANCERS"] = "Atmospheric Enhancers";
    CardName["BOARD_OF_DIRECTORS"] = "Board of Directors";
    CardName["COLONY_TRADE_HUB"] = "Colony Trade Hub";
    CardName["CORRIDORS_OF_POWER"] = "Corridors of Power";
    CardName["EARLY_COLONIZATION"] = "Early Colonization";
    CardName["FLOATING_TRADE_HUB"] = "Floating Trade Hub";
    CardName["FOCUSED_ORGANIZATION"] = "Focused Organization";
    CardName["HIGH_CIRCLES"] = "High Circles";
    CardName["INDUSTRIAL_COMPLEX"] = "Industrial Complex";
    CardName["MAIN_BELT_ASTEROIDS"] = "Main Belt Asteroids";
    CardName["NOBEL_PRIZE"] = "Nobel Prize";
    CardName["OLD_MINING_COLONY"] = "Old Mining Colony";
    CardName["PLANETARY_ALLIANCE"] = "Planetary Alliance";
    CardName["PRESERVATION_PROGRAM"] = "Preservation Program";
    CardName["PROJECT_EDEN"] = "Project Eden";
    CardName["RECESSION"] = "Recession";
    CardName["RISE_TO_POWER"] = "Rise To Power";
    CardName["SOIL_BACTERIA"] = "Soil Bacteria";
    CardName["SPACE_LANES"] = "Space Lanes";
    CardName["SUITABLE_INFRASTRUCTURE"] = "Suitable Infrastructure";
    CardName["TERRAFORMING_DEAL"] = "Terraforming Deal";
    CardName["VENUS_CONTRACT"] = "Venus Contract";
    CardName["VENUS_L1_SHADE"] = "Venus L1 Shade";
    CardName["WORLD_GOVERNMENT_ADVISOR"] = "World Government Advisor";
    // Prelude 2 Corps
    CardName["NIRGAL_ENTERPRISES"] = "Nirgal Enterprises";
    CardName["PALLADIN_SHIPPING"] = "Palladin Shipping";
    CardName["ECOTEC"] = "EcoTec";
    CardName["SAGITTA_FRONTIER_SERVICES"] = "Sagitta Frontier Services";
    CardName["SPIRE"] = "Spire";
    // Promo cards
    CardName["DUSK_LASER_MINING"] = "Dusk Laser Mining";
    CardName["PROJECT_INSPECTION"] = "Project Inspection";
    CardName["ENERGY_MARKET"] = "Energy Market";
    CardName["HI_TECH_LAB"] = "Hi-Tech Lab";
    CardName["INTERPLANETARY_TRADE"] = "Interplanetary Trade";
    CardName["LAW_SUIT"] = "Law Suit";
    CardName["MERCURIAN_ALLOYS"] = "Mercurian Alloys";
    CardName["ORBITAL_CLEANUP"] = "Orbital Cleanup";
    CardName["POLITICAL_ALLIANCE"] = "Political Alliance";
    CardName["REGO_PLASTICS"] = "Rego Plastics";
    CardName["SATURN_SURFING"] = "Saturn Surfing";
    CardName["STANFORD_TORUS"] = "Stanford Torus";
    CardName["ASTEROID_HOLLOWING"] = "Asteroid Hollowing";
    CardName["COMET_AIMING"] = "Comet Aiming";
    CardName["CRASH_SITE_CLEANUP"] = "Crash Site Cleanup";
    CardName["CUTTING_EDGE_TECHNOLOGY"] = "Cutting Edge Technology";
    CardName["DIRECTED_IMPACTORS"] = "Directed Impactors";
    CardName["FIELD_CAPPED_CITY"] = "Field-Capped City";
    CardName["MAGNETIC_SHIELD"] = "Magnetic Shield";
    CardName["MELTWORKS"] = "Meltworks";
    CardName["MOHOLE_LAKE"] = "Mohole Lake";
    CardName["DIVERSITY_SUPPORT"] = "Diversity Support";
    CardName["JOVIAN_EMBASSY"] = "Jovian Embassy";
    CardName["TOPSOIL_CONTRACT"] = "Topsoil Contract";
    CardName["IMPORTED_NUTRIENTS"] = "Imported Nutrients";
    CardName["ASTEROID_DEFLECTION_SYSTEM"] = "Asteroid Deflection System";
    CardName["SUB_CRUST_MEASUREMENTS"] = "Sub-Crust Measurements";
    CardName["POTATOES"] = "Potatoes";
    CardName["MEAT_INDUSTRY"] = "Meat Industry";
    CardName["DEIMOS_DOWN_PROMO"] = "Deimos Down:promo";
    CardName["GREAT_DAM_PROMO"] = "Great Dam:promo";
    CardName["MAGNETIC_FIELD_GENERATORS_PROMO"] = "Magnetic Field Generators:promo";
    CardName["ASTEROID_RIGHTS"] = "Asteroid Rights";
    CardName["BIO_PRINTING_FACILITY"] = "Bio Printing Facility";
    CardName["BACTOVIRAL_RESEARCH"] = "Bactoviral Research";
    CardName["HARVEST"] = "Harvest";
    CardName["OUTDOOR_SPORTS"] = "Outdoor Sports";
    CardName["NEW_PARTNER"] = "New Partner";
    CardName["MERGER"] = "Merger";
    CardName["CORPORATE_ARCHIVES"] = "Corporate Archives";
    CardName["DOUBLE_DOWN"] = "Double Down";
    CardName["PSYCHE"] = "16 Psyche";
    CardName["ROBOT_POLLINATORS"] = "Robot Pollinators";
    CardName["HEAD_START"] = "Head Start";
    CardName["SUPERCAPACITORS"] = "Supercapacitors";
    CardName["DIRECTED_HEAT_USAGE"] = "Directed Heat Usage";
    CardName["ANTI_DESERTIFICATION_TECHNIQUES"] = "Anti-desertification Techniques";
    CardName["AQUEDUCT_SYSTEMS"] = "Aqueduct Systems";
    CardName["ASTRA_MECHANICA"] = "Astra Mechanica";
    CardName["CARBON_NANOSYSTEMS"] = "Carbon Nanosystems";
    CardName["KUIPER_COOPERATIVE"] = "Kuiper Cooperative";
    CardName["TYCHO_MAGNETICS"] = "Tycho Magnetics";
    CardName["CYBERIA_SYSTEMS"] = "Cyberia Systems";
    CardName["ESTABLISHED_METHODS"] = "Established Methods";
    CardName["GIANT_SOLAR_COLLECTOR"] = "Giant Solar Collector";
    CardName["HERMETIC_ORDER_OF_MARS"] = "Hermetic Order of Mars";
    CardName["HOMEOSTASIS_BUREAU"] = "Homeostasis Bureau";
    CardName["KAGUYA_TECH"] = "Kaguya Tech";
    CardName["MARS_NOMADS"] = "Mars Nomads";
    CardName["MARTIAN_LUMBER_CORP"] = "Martian Lumber Corp";
    CardName["NEPTUNIAN_POWER_CONSULTANTS"] = "Neptunian Power Consultants";
    CardName["RED_SHIPS"] = "Red Ships";
    CardName["SOLAR_LOGISTICS"] = "Solar Logistics";
    CardName["ST_JOSEPH_OF_CUPERTINO_MISSION"] = "St. Joseph of Cupertino Mission";
    CardName["STRATEGIC_BASE_PLANNING"] = "Strategic Base Planning";
    CardName["TESLARACT"] = "Teslaract";
    CardName["ICY_IMPACTORS"] = "Icy Impactors";
    CardName["SOIL_ENRICHMENT"] = "Soil Enrichment";
    CardName["CITY_PARKS"] = "City Parks";
    CardName["SUPERMARKETS"] = "Supermarkets";
    CardName["HOSPITALS"] = "Hospitals";
    CardName["PUBLIC_BATHS"] = "Public Baths";
    CardName["PROTECTED_GROWTH"] = "Protected Growth";
    CardName["VERMIN"] = "Vermin";
    CardName["CASINOS"] = "Casinos";
    CardName["PUBLIC_PLANS"] = "Public Plans";
    CardName["STATIC_HARVESTING"] = "Static Harvesting";
    CardName["WEATHER_BALLOONS"] = "Weather Balloons";
    CardName["ALBEDO_PLANTS"] = "Albedo Plants";
    CardName["STERLING_VENTS"] = "Sterling Vents";
    CardName["BOOM_TOWN"] = "Boom Town";
    // Promo cards from Dutch Open
    CardName["FLOYD_CONTINUUM"] = "Floyd Continuum";
    CardName["NEW_HOLLAND"] = "New Holland";
    CardName["POLDERTECH_DUTCH"] = "PolderTECH Dutch";
    // End of promo cards
    // Sillyfication (silly fan expansion)
    CardName["MICRO_CREDITS"] = "Micro Credits";
    CardName["ORBITAL_SEED_DISPERSAL"] = "Orbital Seed Dispersal";
    CardName["THERMAL_FORESTS"] = "Thermal Forests";
    CardName["VOLCANIC_MINERALS"] = "Volcanic Minerals";
    CardName["MACRO_MILLS"] = "Macro Mills";
    CardName["FUNGAL_FRENZY"] = "Fungal Frenzy";
    CardName["VENUSIAN_SUBSIDIARY"] = "Venusian Subsidiary";
    CardName["VENUSIAN_BEES"] = "Venusian Bees";
    CardName["SOME_ASSEMBLY_REQUIRED"] = "Some Assembly Required";
    CardName["PERCUSSIVE_REACTOR"] = "Percussive Reactor";
    CardName["PEER_REVIEW"] = "Peer Review";
    CardName["FAILED_EXPERIMENT"] = "Failed Experiment";
    CardName["DISRUPTIVE_STARTUP"] = "Disruptive Startup";
    CardName["UNPAID_ELECTRICITY_BILL"] = "Unpaid Electricity Bill";
    CardName["GAS_GIANT_TOURISM_BOARD"] = "Gas Giant Tourism Board";
    CardName["NEPTUNE_RESEARCH_VESSEL"] = "Neptune Research Vessel";
    CardName["POTHOLE"] = "Pothole";
    CardName["LOREM_IPSUM"] = "Lorem Ipsum";
    CardName["COMMITTEE_TO_FORM_A_COMMITTEE"] = "Committee to Form a Committee";
    CardName["ROUNDING_ERROR"] = "Rounding Error";
    CardName["LONG_DISTANCE_RELATIONS"] = "Long Distance Relations";
    CardName["MICRO_ENERGY"] = "Micro Energy";
    CardName["MICRO_STEEL"] = "Micro Steel";
    CardName["MICRO_PLANT"] = "Micro Plant";
    CardName["MICRO_TITANIUM"] = "Micro Titanium";
    CardName["SCAFFOLDING_FOREVER"] = "Scaffolding Forever";
    CardName["CORE_MINES"] = "Core Mines";
    CardName["MINERAL_FABRICATORS"] = "Mineral Fabricators";
    CardName["THERMAL_SMELTERY"] = "Thermal Smeltery";
    CardName["DEBRIS_FIELD"] = "Debris Field";
    CardName["ORBIT_DUMPING"] = "Orbit Dumping";
    CardName["GARBAGE_DUMPS"] = "Garbage Dumps";
    CardName["LAUNCH_WINDOW"] = "Launch Window";
    CardName["GLOBAL_ENERGY_INFRASTRUCTURE"] = "Global Energy Infrastructure";
    CardName["CROP_THEFT"] = "Crop Theft";
    CardName["SWAPEROO"] = "Swaperoo";
    CardName["SWITCHAROO"] = "Switcharoo";
    CardName["HORSES"] = "Horses";
    CardName["CRITTERWORLD"] = "Critterworld";
    CardName["ARI_ADORE"] = "Ari-Adore";
    CardName["CHIP_FABRICATION_PLANT"] = "Chip Fabrication Plant";
    CardName["URANUS_SEA_CREATURES"] = "Uranus Sea Creatures";
    CardName["LIVESTOCK_LOBBY"] = "Livestock Lobby";
    CardName["ROBINITTA"] = "Robinitta";
    CardName["CHILLING_RICHES"] = "Chilling Riches";
    CardName["COLD_LIKE_STEEL"] = "Cold like Steel";
    CardName["STEEL_PHOBO"] = "SteelPhobo";
    CardName["PHARMACY_ON_LUNA"] = "Pharmacy on Luna";
    CardName["VITOR_VITALIS"] = "Vitor Vitalis";
    CardName["CORRUPT_GOVERNORS"] = "Corrupt Governors";
    CardName["OVERCROWDED_COLONY"] = "Overcrowded Colony";
    CardName["NECROTIC_BLOOM"] = "Necrotic Bloom";
    CardName["GUERRILLA_GARDENING"] = "Guerrilla Gardening";
    CardName["SLASH_AND_BURN"] = "Slash and Burn";
    CardName["COLONY_SALE"] = "Colony Sale";
    CardName["OUTPOST_ON_EUROPA"] = "Outpost on Europa";
    CardName["NEPOTISM"] = "Nepotism";
    CardName["ROTATING_HANDS"] = "Rotating Hands";
    CardName["SHOW_AND_TELL"] = "Show and Tell";
    CardName["MUSICAL_CHAIRS"] = "Musical Chairs";
    CardName["PRELUDE_CLONING"] = "Prelude Cloning";
    CardName["PROJECT_IMITATORS"] = "Project Imitators";
    CardName["DEIMOS_DOUBLE_DOWN"] = "Deimos Double Down?";
    CardName["DEIMOS_DOUBLE_DOWN_COPY"] = "Double Down Copy";
    CardName["WELLNESS_DELUXE"] = "Wellness Deluxe";
    CardName["VENUS_VENTURES"] = "Venus Ventures";
    CardName["NEREID_BIOSYSTEMS"] = "Nereid Biosystems";
    CardName["SIGNAL_UNION"] = "Signal Union";
    CardName["COST_INDEX"] = "Cost Index";
    CardName["CUTOUT_NETWORKS"] = "Cutout Networks";
    CardName["DEAD_DROP"] = "Dead Drop";
    CardName["THE_SYNDICATE"] = "The Syndicate";
    CardName["EVERGREEN_FOREST"] = "Evergreen Forest";
    CardName["IDEA_BUDGETING"] = "Idea Budgeting";
    CardName["FIRST_MISSION_TO_GANYMEDE"] = "First Mission to Ganymede";
    CardName["SLUMS"] = "Slums";
    CardName["STARTING_TOWN"] = "Starting Town";
    CardName["LONELY_TOWN"] = "Lonely Town";
    // Formerly the separate Teco fan expansion, merged into Sillyfication.
    CardName["MOON_COW"] = "Moon Cow";
    CardName["UNDERGROUND_WORMS"] = "Underground Worms";
    CardName["VENUPHILE"] = "Venuphile";
    CardName["TAG_TAXER"] = "Tag Taxer";
    CardName["AMPHIBIANS"] = "Amphibians";
    CardName["COLD_BLOODED"] = "Cold Blooded";
    CardName["SPACE_OFFICE"] = "Space Office";
    CardName["PLANT_EATER"] = "Plant Eater";
    CardName["SMELTING_PODS"] = "Smelting Pods";
    CardName["MANUWHACK"] = "Manuwhack";
    CardName["BURN_THE_FOREST"] = "Burn the Forest";
    CardName["CATS"] = "Cats";
    CardName["GENEROUS_REDISTRIBUTION"] = "Generous Redistribution";
    CardName["SLOW_START"] = "Slow Start";
    CardName["PRELUDE_GAMBIT"] = "Prelude Gambit";
    CardName["BALANCE"] = "Balance";
    CardName["MARS_HOMESTEAD_ACT"] = "Mars Homestead Act";
    CardName["INSIDER_TRADING"] = "Insider Trading";
    CardName["MARKET_CRASH"] = "Market Crash";
    CardName["SHARED_KNOWLEDGE"] = "Shared Knowledge";
    CardName["SPIRE_TECH"] = "SpireTech";
    CardName["ANIMAL_SHELTER"] = "Animal Shelter";
    CardName["JUPITER"] = "Jupiter";
    CardName["GAMBLING_PROBLEM"] = "Gambling Problem";
    CardName["RAW_ENERGY"] = "Raw Energy";
    CardName["PURE_ENERGY"] = "Pure Energy";
    CardName["INSURANCE"] = "Insurance";
    CardName["ENERGY_HARVEST"] = "Energy Harvest";
    CardName["ELECTROBIC"] = "Electrobic";
    CardName["MICROBETRONICS"] = "Microbetronics";
    CardName["MICROBITIC"] = "Microbitic";
    CardName["RESEARCH_PHASE"] = "Research Phase";
    CardName["BLOCKHOUSE"] = "Blockhouse";
    CardName["MULLIGANS"] = "Mulligans";
    CardName["MULLIGENS"] = "Mulligens";
    CardName["SAND_CLAIM"] = "Sand Claim";
    // BetterMars replacement cards (swap into the base pool when BetterMars is on)
    CardName["LUNAR_BEAM_BETTER_MARS"] = "Lunar Beam:bm";
    CardName["LUNA_METROPOLIS_BETTER_MARS"] = "Luna Metropolis:bm";
    CardName["LUNAR_EXPORTS_BETTER_MARS"] = "Lunar Exports:bm";
    CardName["PRISTAR_BETTER_MARS"] = "Pristar:bm";
    CardName["EARLY_SETTLEMENT_BETTER_MARS"] = "Early Settlement:bm";
    CardName["SELF_SUFFICIENT_SETTLEMENT_BETTER_MARS"] = "Self-Sufficient Settlement:bm";
    CardName["EOS_CHASMA_NATIONAL_PARK_BETTER_MARS"] = "Eos Chasma National Park:bm";
    CardName["IMMIGRATION_SHUTTLES_BETTER_MARS"] = "Immigration Shuttles:bm";
    CardName["MARTIAN_RAILS_BETTER_MARS"] = "Martian Rails:bm";
    CardName["NOCTIS_CITY_BETTER_MARS"] = "Noctis City:bm";
    CardName["NOCTIS_FARMING_BETTER_MARS"] = "Noctis Farming:bm";
    CardName["PROTECTED_VALLEY_BETTER_MARS"] = "Protected Valley:bm";
    CardName["MARS_UNIVERSITY_BETTER_MARS"] = "Mars University:bm";
    CardName["PROTECTED_HABITATS_BETTER_MARS"] = "Protected Habitats:bm";
    CardName["TROPICAL_RESORT_BETTER_MARS"] = "Tropical Resort:bm";
    CardName["MARTIAN_MEDIA_CENTER_BETTER_MARS"] = "Martian Media Center:bm";
    CardName["MEAT_INDUSTRY_BETTER_MARS"] = "Meat Industry:bm";
    CardName["LUNAR_MINING_BETTER_MARS"] = "Lunar Mining:bm";
    CardName["LUNA_GOVERNOR_BETTER_MARS"] = "Luna Governor:bm";
    // Community corps
    CardName["AEROTECH"] = "Aerotech";
    CardName["AGRICOLA_INC"] = "Agricola Inc";
    CardName["CURIOSITY_II"] = "Curiosity II";
    CardName["INCITE"] = "Incite";
    CardName["MIDAS"] = "Midas";
    CardName["PLAYWRIGHTS"] = "Playwrights";
    CardName["PROJECT_WORKSHOP"] = "Project Workshop";
    CardName["UNITED_NATIONS_MISSION_ONE"] = "United Nations Mission One";
    CardName["JUNK_VENTURES"] = "Junk Ventures";
    CardName["ERIS"] = "Eris";
    CardName["ATHENA"] = "Athena";
    // Community preludes
    CardName["VALUABLE_GASES"] = "Valuable Gases";
    CardName["RESEARCH_GRANT"] = "Research Grant";
    CardName["AEROSPACE_MISSION"] = "Aerospace Mission";
    CardName["TRADE_ADVANCE"] = "Trade Advance";
    CardName["POLITICAL_UPRISING"] = "Political Uprising";
    CardName["BY_ELECTION"] = "By-Election";
    CardName["EXECUTIVE_ORDER"] = "Executive Order";
    // Community colonies
    CardName["SCIENCE_TAG_BLANK_CARD"] = "";
    // For Playwright.
    CardName["SPECIAL_DESIGN_PROXY"] = "Special Design:proxy";
    // Proxy for when Executor is used for Global Events.
    CardName["GLOBAL_EVENT_PROXY"] = "Global Event Proxy";
    // Automa
    CardName["AUTOMA_METEOR_SHOWER"] = "Meteor Shower:automa";
    CardName["AUTOMA_INVASIVE_SPECIES"] = "Invasive Species:automa";
    CardName["AUTOMA_RESEARCH_AND_DEVELOPMENT"] = "Research and Development:automa";
    CardName["AUTOMA_OVERACHIEVEMENT"] = "Overachievement:automa";
    CardName["AUTOMA_EXPEDITED_CONSTRUCTION"] = "Expedited Construction:automa";
    CardName["AUTOMA_LOBBYISTS"] = "Lobbyists:automa";
    CardName["AUTOMA_LOCAL_NEURAL_INSTANCE"] = "Local Neural Instance:automa";
    CardName["AUTOMA_CORPORATE_COMPETITION"] = "Corporate Competition:automa";
    // Ares expansion.
    CardName["BIOENGINEERING_ENCLOSURE"] = "Bioengineering Enclosure";
    CardName["BIOFERTILIZER_FACILITY"] = "Bio-Fertilizer Facility";
    CardName["BUTTERFLY_EFFECT"] = "Butterfly Effect";
    CardName["CAPITAL_ARES"] = "Capital:ares";
    CardName["COMMERCIAL_DISTRICT_ARES"] = "Commercial District:ares";
    CardName["DEIMOS_DOWN_ARES"] = "Deimos Down:ares";
    CardName["DESPERATE_MEASURES"] = "Desperate Measures";
    CardName["ECOLOGICAL_SURVEY"] = "Ecological Survey";
    CardName["ECOLOGICAL_ZONE_ARES"] = "Ecological Zone:ares";
    CardName["GEOLOGICAL_SURVEY"] = "Geological Survey";
    CardName["GREAT_DAM_ARES"] = "Great Dam:ares";
    CardName["INDUSTRIAL_CENTER_ARES"] = "Industrial Center:ares";
    CardName["LAVA_FLOWS_ARES"] = "Lava Flows:ares";
    CardName["MAGNETIC_FIELD_GENERATORS_ARES"] = "Magnetic Field Generators:ares";
    CardName["MARKETING_EXPERTS"] = "Marketing Experts";
    CardName["METALLIC_ASTEROID"] = "Metallic Asteroid";
    CardName["MINING_AREA_ARES"] = "Mining Area:ares";
    CardName["MINING_RIGHTS_ARES"] = "Mining Rights:ares";
    CardName["MOHOLE_AREA_ARES"] = "Mohole Area:ares";
    CardName["NATURAL_PRESERVE_ARES"] = "Natural Preserve:ares";
    CardName["NUCLEAR_ZONE_ARES"] = "Nuclear Zone:ares";
    CardName["OCEAN_CITY"] = "Ocean City";
    CardName["OCEAN_FARM"] = "Ocean Farm";
    CardName["OCEAN_SANCTUARY"] = "Ocean Sanctuary";
    CardName["RESTRICTED_AREA_ARES"] = "Restricted Area:ares";
    CardName["SOLAR_FARM"] = "Solar Farm";
    // The Moon.
    CardName["MARE_NECTARIS_MINE"] = "Mare Nectaris Mine";
    CardName["MARE_NUBIUM_MINE"] = "Mare Nubium Mine";
    CardName["MARE_IMBRIUM_MINE"] = "Mare Imbrium Mine";
    CardName["MARE_SERENITATIS_MINE"] = "Mare Serenitatis Mine";
    CardName["HABITAT_14"] = "Habitat 14";
    CardName["GEODESIC_TENTS"] = "Geodesic Tents";
    CardName["SPHERE_HABITATS"] = "Sphere Habitats";
    CardName["THE_WOMB"] = "The Womb";
    CardName["TYCHO_ROAD_NETWORK"] = "Tycho Road Network";
    CardName["ARISTARCHUS_ROAD_NETWORK"] = "Aristarchus Road Network";
    CardName["SINUS_IRDIUM_ROAD_NETWORK"] = "Sinus Irdium Road Network";
    CardName["MOMENTUM_VIRUM_HABITAT"] = "Momentum Virium Habitat";
    CardName["LUNA_TRADE_STATION"] = "Luna Trade Station";
    CardName["LUNA_MINING_HUB"] = "Luna Mining Hub";
    CardName["LUNA_TRAIN_STATION"] = "Luna Train Station";
    CardName["COLONIST_SHUTTLES"] = "Colonist Shuttles";
    CardName["LUNAR_DUST_PROCESSING_PLANT"] = "Lunar Dust Processing Plant";
    CardName["DEEP_LUNAR_MINING"] = "Deep Lunar Mining";
    CardName["ANCIENT_SHIPYARDS"] = "Ancient Shipyards";
    CardName["LUNA_PROJECT_OFFICE"] = "Luna Project Office";
    CardName["LUNA_RESORT"] = "Luna Resort";
    CardName["LUNAR_OBSERVATION_POST"] = "Lunar Observation Post";
    CardName["MINING_ROBOTS_MANUF_CENTER"] = "Mining Robots Manuf. Center";
    CardName["PRIDE_OF_THE_EARTH_ARKSHIP"] = "Pride of the Earth Arkship";
    CardName["IRON_EXTRACTION_CENTER"] = "Iron Extraction Center";
    CardName["TITANIUM_EXTRACTION_CENTER"] = "Titanium Extraction Center";
    CardName["ARCHIMEDES_HYDROPONICS_STATION"] = "Archimedes Hydroponics Station";
    CardName["STEEL_MARKET_MONOPOLISTS"] = "Steel Market Monopolists";
    CardName["TITANIUM_MARKET_MONOPOLISTS"] = "Titanium Market Monopolists";
    CardName["LUNA_STAGING_STATION"] = "Luna Staging Station";
    CardName["NEW_COLONY_PLANNING_INITIAITIVES"] = "New Colony Planning Initiatives";
    CardName["AI_CONTROLLED_MINE_NETWORK"] = "AI Controlled Mine Network";
    CardName["DARKSIDE_METEOR_BOMBARDMENT"] = "Darkside Meteor Bombardment";
    CardName["UNDERGROUND_DETONATORS"] = "Underground Detonators";
    CardName["LUNAR_TRADE_FLEET"] = "Lunar Trade Fleet";
    CardName["SUBTERRANEAN_HABITATS"] = "Subterranean Habitats";
    CardName["IMPROVED_MOON_CONCRETE"] = "Improved Moon Concrete";
    CardName["MOONCRATE_BLOCK_FACTORY"] = "Mooncrate Block Factory";
    CardName["HEAVY_DUTY_ROVERS"] = "Heavy Duty Rovers";
    CardName["MICROSINGULARITY_PLANT"] = "Microsingularity Plant";
    CardName["HELIOSTAT_MIRROR_ARRAY"] = "Heliostat Mirror Array";
    CardName["LUNAR_SECURITY_STATIONS"] = "Lunar Security Stations";
    CardName["HYPERSENSITIVE_SILICON_CHIP_FACTORY"] = "Hypersensitive Silicon Chip Factory";
    CardName["COPERNICUS_SOLAR_ARRAYS"] = "Copernicus Solar Arrays";
    CardName["DARKSIDE_INCUBATION_PLANT"] = "Darkside Incubation Plant";
    CardName["WATER_TREATMENT_COMPLEX"] = "Water Treatment Complex";
    CardName["ALGAE_BIOREACTORS"] = "Algae Bioreactors";
    CardName["HE3_FUSION_PLANT"] = "HE3 Fusion Plant";
    CardName["HE3_REFINERY"] = "HE3 Refinery";
    CardName["HE3_LOBBYISTS"] = "HE3 Lobbyists";
    CardName["REVOLTING_COLONISTS"] = "Revolting Colonists";
    CardName["COSMIC_RADIATION"] = "Cosmic Radiation";
    CardName["OFF_WORLD_CITY_LIVING"] = "Off-World City Living";
    CardName["ROAD_PIRACY"] = "Road Piracy";
    CardName["LUNAR_MINE_URBANIZATION"] = "Lunar Mine Urbanization";
    CardName["THORIUM_RUSH"] = "Thorium Rush";
    CardName["HE3_PRODUCTION_QUOTAS"] = "HE3 Production Quotas";
    CardName["LUNA_CONFERENCE"] = "Luna Conference";
    CardName["WE_GROW_AS_ONE"] = "We Grow As One";
    CardName["MOONCRATE_CONVOYS_TO_MARS"] = "Mooncrate Convoys To Mars";
    CardName["LUNAR_INDEPENDENCE_WAR"] = "Lunar Independence War";
    CardName["AN_OFFER_YOU_CANT_REFUSE"] = "An Offer You Can't Refuse";
    CardName["PRELIMINARY_DARKSIDE"] = "Preliminary Darkside";
    CardName["HOSTILE_TAKEOVER"] = "Hostile Takeover";
    CardName["SYNDICATE_PIRATE_RAIDS"] = "Syndicate Pirate Raids";
    CardName["DARKSIDE_MINING_SYNDICATE"] = "Darkside Mining Syndicate";
    CardName["HE3_PROPULSION"] = "HE3 Propulsion";
    CardName["STAGING_STATION_BEHEMOTH"] = "Staging Station \"Behemoth\"";
    CardName["LUNA_ARCHIVES"] = "Luna Archives";
    CardName["LUNA_SENATE"] = "Luna Senate";
    CardName["LUNA_POLITICAL_INSTITUTE"] = "Luna Political Institute";
    CardName["COPERNICUS_TOWER"] = "Copernicus Tower";
    CardName["SMALL_DUTY_ROVERS"] = "Small Duty Rovers";
    CardName["LUNAR_INDUSTRY_COMPLEX"] = "Lunar Industry Complex";
    CardName["DARKSIDE_OBSERVATORY"] = "Darkside Observatory";
    CardName["MARTIAN_EMBASSY"] = "Martian Embassy";
    CardName["EARTH_EMBASSY"] = "Earth Embassy";
    CardName["ROVER_DRIVERS_UNION"] = "Rover Drivers Union";
    CardName["LTF_HEADQUARTERS"] = "L.T.F. Headquarters";
    CardName["DARKSIDE_SMUGGLERS_UNION"] = "Darkside Smugglers' Union";
    CardName["UNDERMOON_DRUG_LORDS_NETWORK"] = "Undermoon Drug Lords Network";
    CardName["LTF_PRIVILEGES"] = "L.T.F. Privileges";
    CardName["GRAND_LUNA_ACADEMY"] = "Grand Luna Academy";
    CardName["LUNA_ECUMENOPOLIS"] = "Luna Ecumenopolis";
    CardName["ORBITAL_POWER_GRID"] = "Orbital Power Grid";
    CardName["PROCESSOR_FACTORY"] = "Processor Factory";
    CardName["LUNAR_STEEL"] = "Lunar Steel";
    CardName["RUST_EATING_BACTERIA"] = "Rust Eating Bacteria";
    CardName["SOLAR_PANEL_FOUNDRY"] = "Solar Panel Foundry";
    CardName["MOON_TETHER"] = "Moon Tether";
    CardName["NANOTECH_INDUSTRIES"] = "Nanotech Industries";
    CardName["TEMPEST_CONSULTANCY"] = "Tempest Consultancy";
    CardName["THE_DARKSIDE_OF_THE_MOON_SYNDICATE"] = "The Darkside of The Moon Syndicate";
    CardName["LUNA_HYPERLOOP_CORPORATION"] = "Luna Hyperloop Corporation";
    CardName["CRESCENT_RESEARCH_ASSOCIATION"] = "Crescent Research Association";
    CardName["LUNA_FIRST_INCORPORATED"] = "Luna First Incorporated";
    CardName["THE_GRAND_LUNA_CAPITAL_GROUP"] = "The Grand Luna Capital Group";
    CardName["INTRAGEN_SANCTUARY_HEADQUARTERS"] = "Intragen Sanctuary Headquarters";
    CardName["LUNA_TRADE_FEDERATION"] = "Luna Trade Federation";
    CardName["THE_ARCHAIC_FOUNDATION_INSTITUTE"] = "The Archaic Foundation Institute";
    CardName["FIRST_LUNAR_SETTLEMENT"] = "First Lunar Settlement";
    CardName["CORE_MINE"] = "Core Mine";
    CardName["BASIC_INFRASTRUCTURE"] = "Basic Infrastructure";
    CardName["LUNAR_PlANNING_OFFICE"] = "Lunar Planning Office";
    CardName["MINING_COMPLEX"] = "Mining Complex";
    CardName["MOON_ROAD_STANDARD_PROJECT"] = "Road Infrastructure";
    CardName["MOON_MINE_STANDARD_PROJECT"] = "Lunar Mine";
    CardName["MOON_HABITAT_STANDARD_PROJECT"] = "Lunar Habitat";
    CardName["MOON_ROAD_STANDARD_PROJECT_VARIANT_1"] = "Road Infrastructure (var. 1)";
    CardName["MOON_MINE_STANDARD_PROJECT_VARIANT_1"] = "Lunar Mine (var. 1)";
    CardName["MOON_HABITAT_STANDARD_PROJECT_VARIANT_1"] = "Lunar Habitat (var. 1)";
    CardName["MOON_ROAD_STANDARD_PROJECT_VARIANT_2"] = "Road Infrastructure (var. 2)";
    CardName["MOON_MINE_STANDARD_PROJECT_VARIANT_2"] = "Lunar Mine (var. 2)";
    CardName["MOON_HABITAT_STANDARD_PROJECT_VARIANT_2"] = "Lunar Habitat (var. 2)";
    // Pathfinders
    CardName["BREEDING_FARMS"] = "Breeding Farms";
    CardName["PREFABRICATION_OF_HUMAN_HABITATS"] = "Prefabrication of Human Habitats";
    CardName["NEW_VENICE"] = "New Venice";
    CardName["AGRO_DRONES"] = "Agro-Drones";
    CardName["WETLANDS"] = "Wetlands";
    CardName["RARE_EARTH_ELEMENTS"] = "Rare-Earth Elements";
    CardName["ORBITAL_LABORATORIES"] = "Orbital Laboratories";
    CardName["DUST_STORM"] = "Dust Storm";
    CardName["MARTIAN_MONUMENTS"] = "Martian Monuments";
    CardName["MARTIAN_NATURE_WONDERS"] = "Martian Nature Wonders";
    CardName["MUSEUM_OF_EARLY_COLONISATION"] = "Museum of Early Colonisation";
    CardName["TERRAFORMING_CONTROL_STATION"] = "Terraforming Control Station";
    CardName["MARTIAN_TRANSHIPMENT_STATION"] = "Martian Transhipment Station";
    CardName["CERES_SPACEPORT"] = "Ceres Spaceport";
    CardName["DYSON_SCREENS"] = "Dyson Screens";
    CardName["LUNAR_EMBASSY"] = "Lunar Embassy";
    CardName["GEOLOGICAL_EXPEDITION"] = "Geological Expedition";
    CardName["EARLY_EXPEDITION"] = "Early Expedition";
    CardName["HYDROGEN_PROCESSING_PLANT"] = "Hydrogen Processing Plant";
    CardName["POWER_PLANT_PATHFINDERS"] = "Power Plant:Pathfinders";
    CardName["LUXURY_ESTATE"] = "Luxury Estate";
    CardName["RETURN_TO_ABANDONED_TECHNOLOGY"] = "Return to Abandoned Technology";
    CardName["DESIGNED_ORGANISMS"] = "Designed Organisms";
    CardName["SPACE_DEBRIS_CLEANING_OPERATION"] = "Space Debris Cleaning Operation";
    CardName["PRIVATE_SECURITY"] = "Private Security";
    CardName["SECRET_LABS"] = "Secret Labs";
    CardName["CYANOBACTERIA"] = "Cyanobacteria";
    CardName["COMMUNICATION_CENTER"] = "Communication Center";
    CardName["MARTIAN_REPOSITORY"] = "Martian Repository";
    CardName["DATA_LEAK"] = "Data Leak";
    CardName["SMALL_OPEN_PIT_MINE"] = "Small Open Pit Mine";
    CardName["SOLAR_STORM"] = "Solar Storm";
    CardName["SPACE_RELAY"] = "Space Relay";
    CardName["DECLARATION_OF_INDEPENDENCE"] = "Declaration of Independence";
    CardName["MARTIAN_CULTURE"] = "Martian Culture";
    CardName["OZONE_GENERATORS"] = "Ozone Generators";
    CardName["SMALL_COMET"] = "Small Comet";
    CardName["ECONOMIC_ESPIONAGE"] = "Economic Espionage";
    CardName["FLAT_MARS_THEORY"] = "Flat Mars Theory";
    CardName["ASTEROID_RESOURCES"] = "Asteroid Resources";
    CardName["KICKSTARTER"] = "Kickstarter";
    CardName["ECONOMIC_HELP"] = "Economic Help";
    CardName["INTERPLANETARY_TRANSPORT"] = "Interplanetary Transport";
    CardName["MARTIAN_DUST_PROCESSING_PLANT"] = "Martian Dust Processing Plant";
    CardName["CULTIVATION_OF_VENUS"] = "Cultivation of Venus";
    CardName["EXPEDITION_TO_THE_SURFACE_VENUS"] = "Expedition to the Surface - Venus";
    CardName["LAST_RESORT_INGENUITY"] = "Last Resort Ingenuity";
    CardName["CRASHLANDING"] = "Crashlanding";
    CardName["THINK_TANK"] = "Think Tank";
    CardName["BOTANICAL_EXPERIENCE"] = "Botanical Experience";
    CardName["CRYPTOCURRENCY"] = "Cryptocurrency";
    CardName["RICH_DEPOSITS"] = "Rich Deposits";
    CardName["OUMUAMUA_TYPE_OBJECT_SURVEY"] = "Oumuamua Type Object Survey";
    CardName["SOLARPEDIA"] = "Solarpedia";
    CardName["ANTHOZOA"] = "Anthozoa";
    CardName["ADVANCED_POWER_GRID"] = "Advanced Power Grid";
    CardName["SPECIALIZED_SETTLEMENT"] = "Specialized Settlement";
    CardName["CHARITY_DONATION"] = "Charity Donation";
    CardName["CURIOSITY_LABS"] = "Curiosity Labs";
    CardName["NOBEL_LABS"] = "Nobel Labs";
    CardName["HUYGENS_OBSERVATORY"] = "Huygens Observatory";
    CardName["CASSINI_STATION"] = "Cassini Station";
    CardName["MICROBIOLOGY_PATENTS"] = "Microbiology Patents";
    CardName["COORDINATED_RAID"] = "Coordinated Raid";
    CardName["LOBBY_HALLS"] = "Lobby Halls";
    CardName["RED_CITY"] = "Red City";
    CardName["VENERA_BASE"] = "Venera Base";
    CardName["GATEWAY_STATION"] = "Gateway Station";
    CardName["FLOATER_URBANISM"] = "Floater-Urbanism";
    CardName["SOIL_DETOXIFICATION"] = "Soil Detoxification";
    CardName["HIGH_TEMP_SUPERCONDUCTORS"] = "High Temp. Superconductors";
    CardName["PUBLIC_SPONSORED_GRANT"] = "Public Sponsored Grant";
    CardName["POLLINATORS"] = "Pollinators";
    CardName["SOCIAL_EVENTS"] = "Social Events";
    CardName["CONTROLLED_BLOOM"] = "Controlled Bloom";
    CardName["TERRAFORMING_ROBOTS"] = "Terraforming Robots";
    CardName["VENUS_FIRST"] = "Venus First";
    CardName["VALUABLE_GASES_PATHFINDERS"] = "Valuable Gases:Pathfinders";
    CardName["CO2_REDUCERS"] = "CO\u00B2 Reducers";
    CardName["HYDROGEN_BOMBARDMENT"] = "Hydrogen Bombardment";
    CardName["RESEARCH_GRANT_PATHFINDERS"] = "Research Grant:Pathfinders";
    CardName["CREW_TRAINING"] = "Crew Training";
    CardName["SURVEY_MISSION"] = "Survey Mission";
    CardName["DESIGN_COMPANY"] = "Design Company";
    CardName["CONSOLIDATION"] = "Consolidation";
    CardName["PERSONAL_AGENDA"] = "Personal Agenda";
    CardName["VITAL_COLONY"] = "Vital Colony";
    CardName["DEEP_SPACE_OPERATIONS"] = "Deep Space Operations";
    CardName["EXPERIENCED_MARTIANS"] = "Experienced Martians";
    CardName["THE_NEW_SPACE_RACE"] = "The New Space Race";
    CardName["POLARIS"] = "Polaris";
    CardName["PLANET_PR"] = "Planet PR";
    CardName["PLANET_PR_II"] = "Planet PR II";
    CardName["AMBIENT"] = "Ambient";
    CardName["RINGCOM"] = "Ringcom";
    CardName["CHIMERA"] = "Chimera";
    CardName["SISTEMAS_SEEBECK"] = "Sistemas Seebeck";
    CardName["IN_SPIRE"] = "InSpire";
    // SPIRE = 'Spire',
    CardName["SOYLENT_SEEDLING_SYSTEMS"] = "Soylent Seedling Systems";
    CardName["STEELARIS"] = "Steelaris";
    CardName["MARS_MATHS"] = "Mars Maths";
    CardName["MARS_DIRECT"] = "Mars Direct";
    CardName["MARTIAN_INSURANCE_GROUP"] = "Martian Insurance Group";
    CardName["SOLBANK"] = "SolBank";
    CardName["BIO_SOL"] = "Bio-Sol";
    CardName["AURORAI"] = "Aurorai";
    CardName["COLLEGIUM_COPERNICUS"] = "Collegium Copernicus";
    CardName["ROBIN_HAULINGS"] = "Robin Haulings";
    CardName["ODYSSEY"] = "Odyssey";
    CardName["GAGARIN_MOBILE_BASE"] = "Gagarin Mobile Base";
    CardName["MARS_FRONTIER_ALLIANCE"] = "Mars Frontier Alliance";
    CardName["MIND_SET_MARS"] = "Mind Set Mars";
    CardName["HABITAT_MARTE"] = "Habitat Marte";
    CardName["ADHAI_HIGH_ORBIT_CONSTRUCTIONS"] = "Adhai High Orbit Constructions";
    // CEOs
    CardName["ASIMOV"] = "Asimov";
    CardName["BJORN"] = "Bjorn";
    CardName["CLARKE"] = "Clarke";
    CardName["DUNCAN"] = "Duncan";
    CardName["ENDER"] = "Ender";
    CardName["FLOYD"] = "Floyd";
    CardName["GORDON"] = "Gordon";
    CardName["GRETA"] = "Greta";
    CardName["HAL9000"] = "HAL 9000";
    CardName["INGRID"] = "Ingrid";
    CardName["JANSSON"] = "Jansson";
    CardName["KAREN"] = "Karen";
    CardName["LOWELL"] = "Lowell";
    CardName["MUSK"] = "Musk";
    CardName["MARIA"] = "Maria";
    CardName["NAOMI"] = "Naomi";
    CardName["OSCAR"] = "Oscar";
    CardName["PETRA"] = "Petra";
    CardName["QUILL"] = "Quill";
    CardName["ROGERS"] = "Rogers";
    CardName["STEFAN"] = "Stefan";
    CardName["TATE"] = "Tate";
    CardName["ULRICH"] = "Ulrich";
    CardName["VANALLEN"] = "Van Allen";
    CardName["WILL"] = "Will";
    CardName["XAVIER"] = "Xavier";
    CardName["YVONNE"] = "Yvonne";
    CardName["ZAN"] = "Zan";
    CardName["APOLLO"] = "Apollo";
    CardName["CAESAR"] = "Caesar";
    CardName["FARADAY"] = "Faraday";
    CardName["GAIA"] = "Gaia";
    CardName["HUAN"] = "Huan";
    CardName["NEIL"] = "Neil";
    CardName["RYU"] = "Ryu";
    CardName["SHARA"] = "Shara";
    CardName["XU"] = "Xu";
    // CEO Preludes
    CardName["CO_LEADERSHIP"] = "Co-leadership";
    // Star Wars cards
    CardName["TRADE_EMBARGO"] = "Trade Embargo (I)";
    CardName["CLONE_TROOPERS"] = "Clone Troopers (II)";
    CardName["BEHOLD_THE_EMPEROR"] = "Behold The Emperor! (III)";
    CardName["TOSCHE_STATION"] = "Tosche Station (IV)";
    CardName["CLOUD_CITY"] = "Cloud City (V)";
    CardName["FOREST_MOON"] = "Forest Moon (VI)";
    CardName["TAKONDA_CASTLE"] = "Takonda Castle (VII)";
    CardName["TOOL_WITH_THE_FIRST_ORDER"] = "Tool with the First Order (VIII)";
    CardName["REY_SKYWALKER"] = "Rey ... Skywalker?! (IX)";
    // Underworld
    CardName["GEOLOGIST_TEAM"] = "Geologist Team";
    CardName["GEOSCAN_SATELLITE"] = "Geoscan Satellite";
    CardName["TUNNEL_BORING_MACHINE"] = "Tunnel Boring Machine";
    CardName["UNDERGROUND_RAILWAY"] = "Underground Railway";
    CardName["GAIA_CITY"] = "Gaia City";
    CardName["DEEPNUKING"] = "Deepnuking";
    CardName["OLD_WORLD_MAFIA"] = "Old World Mafia";
    CardName["NIGHTCLUBS"] = "Nightclubs";
    CardName["RECKLESS_DETONATION"] = "Reckless Detonation";
    CardName["OFF_WORLD_TAX_HAVEN"] = "Off-World Tax Haven";
    CardName["SUBNAUTIC_PIRATES"] = "Subnautic Pirates";
    CardName["SOCIAL_ENGINEERING"] = "Social Engineering";
    CardName["FABRICATED_SCANDAL"] = "Fabricated Scandal";
    CardName["LABOR_TRAFFICKING"] = "Labor Trafficking";
    CardName["SUBTERRANEAN_SEA"] = "Subterranean Sea";
    CardName["FOREST_TUNNELS"] = "Forest Tunnels";
    CardName["MAN_MADE_VOLCANO"] = "Man-made Volcano";
    CardName["TUNNELING_SUBCONTRACTOR"] = "Tunneling Subcontractor";
    CardName["UNDERGROUND_AMUSEMENT_PARK"] = "Underground Amusement Park";
    CardName["CASINO"] = "Casino";
    CardName["IMPORTED_HEAVY_MACHINERY"] = "Imported Heavy Machinery";
    CardName["MICROPROBING_TECHNOLOGY"] = "Microprobing Technology";
    CardName["SEARCH_FOR_LIFE_UNDERGROUND"] = "Search for Life Underground";
    CardName["GEOTHERMAL_NETWORK"] = "Geothermal Network";
    CardName["GLOBAL_AUDIT"] = "Global Audit";
    CardName["PATENT_MANIPULATION"] = "Patent Manipulation";
    CardName["CAVE_CITY"] = "Cave City";
    CardName["UNDERGROUND_SMUGGLING_RING"] = "Underground Smuggling Ring";
    CardName["DEEPMINING"] = "Deepmining";
    CardName["BEHEMOTH_EXCAVATOR"] = "Behemoth Excavator";
    CardName["LOBBYING_NETWORK"] = "Lobbying Network";
    CardName["TUNNELING_LOOPHOLE"] = "Tunneling Loophole";
    CardName["ORBITAL_LASER_DRILL"] = "Orbital Laser Drill";
    CardName["GREY_MARKET_EXPLOITATION"] = "Grey Market Exploitation";
    CardName["EXCAVATOR_LEASING"] = "Excavator Leasing";
    CardName["LANDFILL"] = "Landfill";
    CardName["NARRATIVE_SPIN"] = "Narrative Spin";
    CardName["PRIVATE_INVESTIGATOR"] = "Private Investigator";
    CardName["CORPORATE_BLACKMAIL"] = "Corporate Blackmail";
    CardName["SCAPEGOAT"] = "Scapegoat";
    CardName["FRIENDS_IN_HIGH_PLACES"] = "Friends in High Places";
    CardName["MICROGRAVIMETRY"] = "Microgravimetry";
    CardName["STEM_FIELD_SUBSIDIES"] = "Stem Field Subsidies";
    CardName["TITAN_MANUFACTURING_COLONY"] = "Titan Manufacturing Colony";
    CardName["ROBOT_MOLES"] = "Robot Moles";
    CardName["MINING_MARKET_INSIDER"] = "Mining Market Insider";
    CardName["SERVER_SABOTAGE"] = "Server Sabotage";
    CardName["SPACE_WARGAMES"] = "Space Wargames";
    CardName["PRIVATE_MILITARY_CONTRACTOR"] = "Private Military Contractor";
    CardName["SPACE_PRIVATEERS"] = "Space Privateers";
    CardName["PERSONAL_SPACECRUISER"] = "Personal Spacecruiser";
    CardName["HYPERSPACE_DRIVE_PROTOTYPE"] = "Hyperspace Drive Prototype";
    CardName["STAR_VEGAS"] = "Star Vegas";
    CardName["PRIVATE_RESORTS"] = "Private Resorts";
    CardName["EARTHQUAKE_MACHINE"] = "Earthquake Machine";
    CardName["MICRO_GEODESICS"] = "Micro-Geodesics";
    CardName["NEUTRINOGRAPH"] = "Neutrinograph";
    CardName["SOIL_EXPORT"] = "Soil Export";
    CardName["ARTESIAN_AQUIFER"] = "Artesian Aquifer";
    CardName["CHEMICAL_FACTORY"] = "Chemical Factory";
    CardName["CORPORATE_THEFT"] = "Corporate Theft";
    CardName["UNDERGROUND_RESEARCH_CENTER"] = "Underground Research Center";
    CardName["PRICE_WARS"] = "Price Wars";
    CardName["ANTI_TRUST_CRACKDOWN"] = "Anti-trust Crackdown";
    CardName["MONOPOLY"] = "Monopoly";
    CardName["STAGED_PROTESTS"] = "Staged Protests";
    CardName["PLANT_TAX"] = "Plant Tax";
    CardName["INFRASTRUCTURE_OVERLOAD"] = "Infrastructure Overload";
    CardName["CRATER_SURVEY"] = "Crater Survey";
    CardName["INDUCED_TREMOR"] = "Induced Tremor";
    CardName["UNDERGROUND_HABITAT"] = "Underground Habitat";
    CardName["UNDERGROUND_SHELTERS"] = "Underground Shelters";
    CardName["VOLUNTEER_MINING_INITIATIVE"] = "Volunteer Mining Initiative";
    CardName["NANOFOUNDRY"] = "Nanofoundry";
    CardName["BATTERY_FACTORY"] = "Battery Factory";
    CardName["VOLTAIC_METALLURGY"] = "Voltaic Metallurgy";
    CardName["PUBLIC_SPACELINE"] = "Public Spaceline";
    CardName["MARTIAN_EXPRESS"] = "Martian Express";
    CardName["EXPEDITION_VEHICLES"] = "Expedition Vehicles";
    CardName["CUT_THROAT_BUDGETING"] = "Cut-throat Budgeting";
    CardName["CANYON_SURVEY"] = "Canyon Survey";
    CardName["CLASS_ACTION_LAWSUIT"] = "Class-action Lawsuit";
    CardName["MERCENARY_SQUAD"] = "Mercenary Squad";
    CardName["RESEARCH_DEVELOPMENT_HUB"] = "Research & Development Hub";
    CardName["PLANETARY_RIGHTS_BUYOUT"] = "Planetary Rights Buyout";
    CardName["MEDIA_FRENZY"] = "Media Frenzy";
    CardName["INVESTIGATIVE_JOURNALISM"] = "Investigative Journalism";
    CardName["WHALES"] = "Whales";
    CardName["GUERILLA_ECOLOGISTS"] = "Guerilla Ecologists";
    CardName["THIOLAVA_VENTS"] = "Thiolava Vents";
    CardName["DETECTIVE_TV_SERIES"] = "Detective TV Series";
    CardName["RACKETEERING"] = "Racketeering";
    CardName["GAS_TRUST"] = "Gas Trust";
    CardName["STING_OPERATION"] = "Sting Operation";
    CardName["FAMILY_CONNECTIONS"] = "Family Connections";
    CardName["BIOBATTERIES"] = "Biobatteries";
    CardName["EXPORT_CONVOY"] = "Export Convoy";
    CardName["ACIDIZING"] = "Acidizing";
    CardName["EXPLOITATION_OF_VENUS"] = "Exploitation Of Venus";
    CardName["DEEP_FOUNDATIONS"] = "Deep Foundations";
    // Underworld Corporations
    CardName["HADESPHERE"] = "Hadesphere";
    CardName["DEMETRON_LABS"] = "Demetron Labs";
    CardName["JENSON_BOYLE_CO"] = "Jenson-Boyle & Co";
    CardName["HENKEI_GENETICS"] = "Henkei Genetics";
    CardName["ARBORIST_COLLECTIVE"] = "Arborist Collective";
    CardName["KINGDOM_OF_TAURARO"] = "Kingdom of Tauraro";
    CardName["AERON_GENOMICS"] = "Aeron Genomics";
    CardName["KEPLERTEC"] = "Keplertec";
    CardName["VOLTAGON"] = "Voltagon";
    CardName["ARES_MEDIA"] = "Ares Media";
    CardName["ANUBIS_SECURITIES"] = "Anubis Securities";
    CardName["HECATE_SPEDITIONS"] = "Hecate Speditions";
    // Underworld Preludes
    CardName["FREE_TRADE_PORT"] = "Free Trade Port";
    CardName["INVESTOR_PLAZA"] = "Investor Plaza";
    CardName["INHERITED_FORTUNE"] = "Inherited Fortune";
    CardName["INTELLECTUAL_PROPERTY_THEFT"] = "Intellectual Property Theft";
    CardName["TUNNELING_OPERATION"] = "Tunneling Operation";
    CardName["GEOLOGICAL_EXPERTISE"] = "Geological Expertise";
    CardName["UNDERGROUND_SETTLEMENT"] = "Underground Settlement";
    CardName["GANYMEDE_TRADING_COMPANY"] = "Ganymede Trading Company";
    CardName["CENTRAL_RESERVOIR"] = "Central Reservoir";
    CardName["BATTERY_SHIPMENT"] = "Battery Shipment";
    CardName["DEEPWATER_DOME"] = "Deepwater Dome";
    CardName["SECRET_RESEARCH"] = "Secret Research";
    CardName["PROSPECTING"] = "Prospecting";
    CardName["ELECTION_SPONSORSHIP"] = "Election Sponsorship";
    CardName["CLOUD_VORTEX_OUTPOST"] = "Cloud Vortex Outpost";
    // Delta Project
    CardName["DELTA_PROJECT"] = "Delta Project";
    CardName["EPSILON_DAMPLE"] = "Epsilon Dample";
    CardName["ZETA_TOLLKEEPER"] = "Zeta Tollkeeper";
    CardName["QUANTUM_RESEARCH"] = "Quantum Research";
    CardName["DELTA_SURGE"] = "Delta Surge";
    CardName["CORPORATE_ESPIONAGE"] = "Corporate Espionage";
    CardName["DELTA_WORKS"] = "Delta Works";
    CardName["DEVELOPMENT_MANAGER"] = "Development Manager";
    CardName["DUTCH_MOUNTAINS"] = "Dutch Mountains";
    CardName["DYNAMIC_OCEAN_BARRIER"] = "Dynamic Ocean Barrier";
    CardName["LITTLE_DUTCH_BOY"] = "Little Dutch Boy";
    CardName["SOCIAL_HEATING"] = "Social Heating";
    CardName["STORM_SURGE_BARRIER"] = "Storm Surge Barrier";
    // Underworld Standard Projects
    CardName["EXCAVATE_STANDARD_PROJECT"] = "Excavate:SP";
    CardName["COLLUSION_STANDARD_PROJECT"] = "Collusion:SP";
    // Underworld Replacement Cards
    CardName["STANDARD_TECHNOLOGY_UNDERWORLD"] = "Standard Technology:u";
    CardName["HACKERS_UNDERWORLD"] = "Hackers:u";
    CardName["HIRED_RAIDERS_UNDERWORLD"] = "Hired Raiders:u";
    // Corporate Betterments (fan expansion)
    CardName["FUTURISTIC_CENTRE"] = "Futuristic Centre";
    CardName["ARCHITECTURAL_CONTRACTS"] = "Architectural Contracts";
    CardName["MARTIAN_SAFARI"] = "Martian Safari";
    CardName["SLOW_GROWTH_PLANTATION"] = "Slow-Growth Plantation";
    CardName["UNDERWATER_OUTPOST"] = "Underwater Outpost";
    CardName["ASTEROID_FRAGMENTATION"] = "Asteroid Fragmentation";
    CardName["WEATHER_CONTROL_CB"] = "Weather Control";
    CardName["INTERPLANETARY_ADVERTISING_NETWORK"] = "Interplanetary Advertising Network";
    CardName["JOVIAN_BELT_MINING_OPERATIONS"] = "Jovian Belt Mining Operations";
    CardName["SEABED_EXTRACTION"] = "Seabed Extraction";
    CardName["GREENERY_EMBELLISHMENT"] = "Greenery Embellishment";
    CardName["VENUSIAN_COLLABORATION"] = "Venusian Collaboration";
    CardName["BIOMASS_REACTOR"] = "Biomass Reactor";
    CardName["GREAT_OCEAN_LABORATORY"] = "Great Ocean Laboratory";
    CardName["INGEGNERI_SPAZIALI"] = "Ingegneri Spaziali";
    CardName["MARTIAN_HOTELS"] = "Martian Hotels";
    CardName["ROOFTOP_GARDENS"] = "Rooftop Gardens";
    CardName["GREEN_AREAS_INTEGRATION"] = "Green Areas Integration";
    CardName["PIPES"] = "Pipes";
    CardName["LUNAR_MANTLE_EXCAVATION"] = "Lunar Mantle Excavation";
    CardName["MICROBE_COLTURES"] = "Microbe Coltures";
    CardName["WILD_BOARS"] = "Wild Boars";
    CardName["EXCESS_WATER"] = "Excess Water";
    CardName["MARKET_MANIPULATION_CB"] = "Market Manipulation (Corporate Betterments)";
    CardName["PHOTOREFLECTORS"] = "Photoreflectors";
    CardName["MONOPOLY_BREAKUP"] = "Monopoly Breakup";
    CardName["IO_THERMALIZATION"] = "Io Thermalization";
    CardName["VENUSIAN_TRANSPORTS"] = "Venusian Transports";
    CardName["SEED_SHARING"] = "Seed Sharing";
    CardName["COMPANY_INCENTIVES"] = "Company Incentives";
    CardName["JOINT_VENTURE"] = "Joint Venture";
    CardName["NUKE_AN_ASTEROID"] = "Nuke an Asteroid";
    CardName["FAMILY_ADVERTISING"] = "Family Advertising";
    CardName["COMPANY_RESTRUCTURING"] = "Company Restructuring";
    CardName["ADVANCED_SCHOOLS"] = "Advanced Schools";
    CardName["VENUSIAN_HEAT_EXCHANGERS"] = "Venusian Heat Exchangers";
    CardName["MASS_URBANIZATION"] = "Mass Urbanization";
    CardName["URBAN_PLANNING_STRATEGIES"] = "Urban Planning Strategies";
    CardName["VENUSIAN_FLUCTUATING_PLANTS"] = "Venusian Fluctuating Plants";
    CardName["TWIN_PLANET_COMMERCE_NETWORK"] = "Twin Planet Commerce Network";
    CardName["ASSISTED_GROWTH_PLANTS"] = "Assisted Growth Plants";
    CardName["MARTIAN_SAMPLES"] = "Martian Samples";
    CardName["ENERGETIC_INFRASTRUCTURES"] = "Energetic Infrastructures";
    CardName["VENUS_EARTH_PARTNERSHIP"] = "Venus-Earth Partnership";
    CardName["BASE_ON_TITAN"] = "Base On Titan";
    CardName["COMPANY_CARTEL"] = "Company Cartel";
    CardName["VENUSIAN_ECOLOGY"] = "Venusian Ecology";
    CardName["SMUGGLING_OPERATIONS"] = "Smuggling Operations";
    CardName["COMPANY_MERGER"] = "Company Merger";
    CardName["AITKEN_DRILLING_OPERATIONS"] = "Aitken Drilling Operations";
    CardName["MARTIAN_LIZARDS"] = "Martian Lizards";
    // Ides of Mars (fan expansion)
    CardName["BUDGET_RESTRICTIONS"] = "Budget Restrictions";
    CardName["PRECIOUS_METAL_ASTEROID"] = "Precious Metal Asteroid";
    CardName["TARGETED_RESEARCH"] = "Targeted Research";
    CardName["SCIENCE_FAIR"] = "Science Fair";
    CardName["PATENT_THEFT"] = "Patent Theft";
    CardName["MUSEUM_OF_TERRAFORMATION"] = "Museum of Terraformation";
    CardName["INDUSTRIAL_SPY"] = "Industrial Spy";
    CardName["FLOATING_BASE_ON_SATURN"] = "Floating Base on Saturn";
    CardName["BUDGET_MANAGEMENT"] = "Budget Management";
    CardName["PLOT_CONTAMINATION"] = "Plot Contamination";
    CardName["MARTIAN_HOUR"] = "Martian Hour";
    CardName["COLLABORATION_CROSS_COMPANIES"] = "Collaboration Cross-Companies";
    CardName["THREE_PLANETS_SYSTEM"] = "Three Planets System";
    CardName["COPYLEFT"] = "Copyleft";
    CardName["ADMINISTRATIVE_DELAY"] = "Administrative Delay";
    CardName["INSECT_POLLINATORS"] = "Insect Pollinators";
    CardName["NEW_FRONTIER"] = "New Frontier";
    CardName["SMALL_DEPOSIT"] = "Small Deposit";
    CardName["CORPORATE_ACQUISITION"] = "Corporate Acquisition";
    CardName["INVESTMENT_INSURANCE"] = "Investment Insurance";
    CardName["COLONY_SCRAPPING"] = "Colony Scrapping";
    CardName["PATENT_POOLING"] = "Patent Pooling";
    CardName["BACKSTABBING"] = "Backstabbing";
    CardName["PUBLIC_RELATIONS"] = "Public Relations";
    CardName["FLYING_GARDEN"] = "Flying Garden";
    CardName["APPLIED_RESEARCH"] = "Applied Research";
    CardName["SPACE_PIRATES"] = "Space Pirates";
    CardName["MARTIAN_INFRASTRUCTURES"] = "Martian Infrastructures";
    CardName["TERRAFORMING_OFFICE"] = "Terraforming Office";
    CardName["FLYING_CORSAIRS"] = "Flying Corsairs";
    CardName["HIDDEN_CITY"] = "Hidden City";
    CardName["BIO_BATTERIES"] = "Bio-Batteries";
    CardName["INVAK_CITY"] = "Invak City";
    CardName["DRAGON_STORM"] = "Dragon Storm";
    CardName["GALILEIAN_TOURISM"] = "Galileian Tourism";
    CardName["TROGLOBITES"] = "Troglobites";
    CardName["FREE_CITY"] = "Free City";
    CardName["AMPHIBIANS_IOM"] = "Amphibians (Ides of Mars)";
    CardName["SOLAR_SENATE"] = "Solar Senate";
    CardName["VENUSIAN_GROUND_LABORATORY"] = "Venusian Ground Laboratory";
    CardName["DARK_VEGETATION"] = "Dark Vegetation";
    CardName["MARTIAN_STOCK_EXCHANGE"] = "Martian Stock Exchange";
    CardName["DERIVED_PRODUCTS"] = "Derived Products";
    CardName["FLOATING_RIG"] = "Floating Rig";
    CardName["ENERGY_SHORTCUT"] = "Energy Shortcut";
    CardName["AIR_TRANSPORT_COMPANY"] = "Air Transport Company";
    CardName["GREAT_LEAP_FORWARD"] = "Great Leap Forward";
    CardName["WATER_CLEANING_BACTERIA"] = "Water Cleaning Bacteria";
    CardName["OVERCONSUMPTION_BENEFITS"] = "Overconsumption Benefits";
    CardName["MERCURIAL_LABORATORY"] = "Mercurial Laboratory";
    CardName["IN_VIVO_TESTING"] = "In-Vivo Testing";
    CardName["WATER_RETAINERS"] = "Water Retainers";
    CardName["SLUM"] = "Slum";
    CardName["BLUE_MARS"] = "Blue Mars";
    CardName["MINING_THE_BELT"] = "Mining the Belt";
    CardName["TAKEOVER"] = "Takeover";
    CardName["INFRASTRUCTURES"] = "Infrastructures";
    CardName["NATURAL_GROWTH_CATALYST"] = "Natural Growth Catalyst";
    CardName["GALAXY_EXPRESS"] = "Galaxy Express";
    CardName["PLEISTOCENE_MEGAFAUNA"] = "Pleistocene Megafauna";
    CardName["REPTILES"] = "Reptiles";
    CardName["OBJECTIVE_MARS"] = "Objective Mars";
    CardName["GALILEO_INSTITUTE"] = "Galileo Institute";
    CardName["UNIVERSAL_FIGHTERS"] = "Universal Fighters";
    // Rob Antilles (fan expansion)
    CardName["SUBURBS"] = "Suburbs";
    CardName["HARBOR_BOREALIS"] = "Harbor Borealis";
    CardName["HISTORICAL_VIDEOGRAPHIC_ARCHIVE"] = "Historical Videographic Archive";
    CardName["INDUSTRIAL_METROPOLIS"] = "Industrial Metropolis";
    CardName["ORC_TURBINES"] = "Orc Turbines";
    CardName["MOBILE_BIOLOGICAL_DOME"] = "Mobile Biological Dome";
    CardName["PARADISE_CITY"] = "Paradise City";
    CardName["GREENHOUSE_LIGHTS"] = "Greenhouse Lights";
    CardName["CACTI"] = "Cacti";
    CardName["CORRUPTED_DELEGATE"] = "Corrupted Delegate";
    CardName["ALIEN_REACTOR_ATIVATION"] = "Alien Reactor Ativation";
    CardName["HUMPBACK_WHALES"] = "Humpback Whales";
    CardName["UPGRADED_SAWS"] = "Upgraded Saws";
    CardName["LAUNCH_OF_THE_PHOENIX"] = "Launch of the Phoenix";
    CardName["UTOPIA_PLANITIA_SPACEPORT"] = "Utopia Planitia Spaceport";
    CardName["MARTIAN_ARMED_FORCES"] = "Martian Armed Forces";
    CardName["EXCAVATION_SYRIA_PLANUM"] = "Excavation Syria Planum";
    CardName["WEATHER_CONTROL_TOWER"] = "Weather Control Tower";
    CardName["CLOUD_CITY_RA"] = "Cloud City";
    CardName["BATTLE_OF_ZADONGA"] = "Battle of Zadonga";
    CardName["TERRAFORMING_BUREAU_RESTRUCTURING"] = "Terraforming Bureau Restructuring";
    CardName["DOGS_IN_SPACE"] = "Dogs in Space";
    CardName["STEM_CELL_RESEARCH_CENTER"] = "Stem Cell Research Center";
    CardName["TROPOSPHERIC_CITY"] = "Tropospheric City";
    CardName["ROOFTOP_GARDENS_OF_NOCTIS"] = "Rooftop Gardens of Noctis";
    CardName["GREAT_LIGHTHOUSE_OF_ALBA_PATERA"] = "Great Lighthouse of Alba Patera";
    CardName["GREAT_FACE_OF_CYDONIA"] = "Great Face of Cydonia";
    CardName["MAUSOLEUM_AT_HELLAS"] = "Mausoleum at Hellas";
    CardName["STATUE_OF_VON_BRAUN_ON_OLYMPUS_MONS"] = "Statue of Von Braun on Olympus Mons";
    CardName["THARSIS_COLOSSUS"] = "Tharsis Colossus";
    CardName["TEMPLE_OF_GAIA_AT_ELYSIUM"] = "Temple of Gaia at Elysium";
    CardName["BATTLE_OVER_MARS"] = "Battle over Mars";
    CardName["LIVESTOCK_GIANT_DOME"] = "Livestock Giant Dome";
    CardName["LIGHTNING_ACCUMULATORS"] = "Lightning Accumulators";
    CardName["MARTIAN_RANGERS"] = "Martian Rangers";
    CardName["BIOREACTORS_RA"] = "Bioreactors";
    CardName["NEPTUNE_EXPEDITION"] = "Neptune Expedition";
    CardName["BIOMASS_CONVERSION_PLANT"] = "Biomass Conversion Plant";
    CardName["OPENING_OF_NATURAL_RESERVES"] = "Opening Of Natural Reserves";
    CardName["CLONATION"] = "Clonation";
    CardName["MUSK_AWARDS"] = "Musk Awards";
    CardName["MONUMENT_TO_MARS"] = "Monument To Mars";
    CardName["SUPERNOVA_EXPLOSION"] = "Supernova Explosion";
    CardName["ORGANIC_WASTE_RECYCLING"] = "Organic Waste Recycling";
    CardName["SMES_TECHNOLOGY"] = "Smes Technology";
    CardName["THARSIS_PUMPING_HUB"] = "Tharsis Pumping Hub";
    CardName["GREAT_MARTIAN_ARCHIVES"] = "Great Martian Archives";
    CardName["PLANETARY_MUSEUM"] = "Planetary Museum";
    CardName["MICROBIOTIC_OCEANIC_FAUNA"] = "Microbiotic Oceanic Fauna";
    CardName["OBSERVATORY_ON_OLYMPUS_MONS"] = "Observatory on Olympus Mons";
    CardName["PREHISTORIC_BEASTS"] = "Prehistoric Beasts";
    CardName["GIGA_INTERFEROMETER"] = "Giga Interferometer";
    CardName["MARTIAN_COMMERCIAL_SEAFLEET"] = "Martian Commercial Seafleet";
    CardName["DATA_LIBRARY"] = "Data Library";
    CardName["MINERAL_DEPOT"] = "Mineral Depot";
    CardName["HEAVY_MACHINERY"] = "Heavy Machinery";
    CardName["SEDIMENTARY_ROCKS"] = "Sedimentary Rocks";
    CardName["EXTRA_VEHICULAR_ACTIVITIES"] = "Extra-Vehicular Activities";
    CardName["ORBITAL_BIOLOGICAL_LABORATORY"] = "Orbital Biological Laboratory";
    CardName["SPACE_ROBOTS"] = "Space Robots";
    CardName["ALGORITHMIC_TRADING"] = "Algorithmic Trading";
    CardName["ECOPLANTS"] = "Ecoplants";
    CardName["MINING_OUTPOST"] = "Mining Outpost";
    CardName["EXPORTS_FROM_AMALTHEA"] = "Exports From Amalthea";
    CardName["INTERPLANETARY_CRUISE"] = "Interplanetary Cruise";
    CardName["MOON_MINERAL_METROPOLIS"] = "Moon Mineral Metropolis";
    CardName["ELECTORAL_CAMPAIGN"] = "Electoral Campaign";
    CardName["METEOR_SHOWER_RA"] = "Meteor Shower";
    CardName["TAX_THE_RICH"] = "Tax The Rich";
    // Venus Phase 2
    // Named "Venus Cloud City" (not just "Cloud City") -- CLOUD_CITY_RA already claims that exact
    // display string for its own, unrelated Rob Antilles card.
    CardName["CLOUD_CITY_STANDARD_PROJECT"] = "Venus Cloud City";
    CardName["GAS_MINE_STANDARD_PROJECT"] = "Gas Mine";
    CardName["FLOATER_ARRAY_STANDARD_PROJECT"] = "Floater Array";
    // Venus Phase 2's own 46-card set (a user-designed mockup deck, filenames 50-96 in the source
    // material -- see venusphase2-cards memory). Ordered by source filename, not alphabetically.
    CardName["OVDA_REGIO_MASS_DRIVER"] = "Ovda Regio Mass Driver";
    CardName["ATMO_SEQUESTER"] = "Atmo Sequester";
    CardName["SOLAR_WIND_TRAP"] = "Solar Wind Trap";
    CardName["VENUSIAN_INFRASTRUCTURES"] = "Venusian Infrastructures";
    CardName["SYNTHETIC_BIOLOGY"] = "Synthetic Biology";
    CardName["BIO_WASTE_REACTOR"] = "Bio-Waste Reactor";
    CardName["IN_SITU_RESOURCE_UTILIZATION"] = "In-Situ Resource Utilization";
    CardName["IMPROVED_FLOATING_SYSTEMS"] = "Improved Floating Systems";
    CardName["MODULAR_QUARTERS"] = "Modular Quarters";
    CardName["NEGATIVE_MASS_FLUIDS"] = "Negative Mass Fluids";
    CardName["TRANSMISSION_TOWERS"] = "Transmission Towers";
    CardName["HEAT_TRAPPERS_NETWORK"] = "Heat Trappers Network";
    CardName["DYSON_HARROP_SATELLITE"] = "Dyson-Harrop Satellite";
    CardName["COOLING_PILLARS"] = "Cooling Pillars";
    CardName["IONIC_THRUSTERS_SUPPORT"] = "Ionic Thrusters Support";
    CardName["NATIVE_MICROFAUNA"] = "Native Microfauna";
    CardName["MENAGERIE"] = "Menagerie";
    CardName["COMPUTATIONAL_BIOLOGY"] = "Computational Biology";
    CardName["OUTSKIRTS"] = "Outskirts";
    CardName["POLLUTION_CONTROL"] = "Pollution Control";
    CardName["INTERPLANETARY_ROUTES"] = "Interplanetary Routes";
    CardName["ARGON_MINE"] = "Argon Mine";
    CardName["ISHTAR_ORBITING_ACADEMY"] = "Ishtar Orbiting Academy";
    CardName["HIGH_PRESSURE_SUITS"] = "High Pressure Suits";
    CardName["NEW_ALEXANDRIA"] = "New Alexandria";
    CardName["GAS_TURBINES"] = "Gas Turbines";
    CardName["SURVEYORS_TEAM"] = "Surveyors Team";
    CardName["VENUS_AIRCRAFT_HAVEN"] = "Venus Aircraft Haven";
    CardName["VENUS_KICKSTARTING"] = "Venus Kickstarting";
    CardName["FLOATER_FACTORY"] = "Floater Factory";
    CardName["STARWIND_II_TRADESHIP"] = "Starwind II Tradeship";
    CardName["SISTER_COLONIES"] = "Sister Colonies";
    CardName["VENUSIAN_RESEARCH_COMMITTEE"] = "Venusian Research Committee";
    CardName["CALLISTO_DOCKING_STATION"] = "Callisto Docking Station";
    CardName["XENON_MINE"] = "Xenon Mine";
    CardName["RADON_MINE"] = "Radon Mine";
    CardName["KRYPTON_MINE"] = "Krypton Mine";
    CardName["NEW_ATHENS"] = "New Athens";
    CardName["ALPHA_REGIO_INCUBATORS"] = "Alpha Regio Incubators";
    CardName["NEW_ROME"] = "New Rome";
    CardName["VENUS_TRADESHIP"] = "Venus Tradeship";
    CardName["VENUSIAN_WANDERER"] = "Venusian Wanderer";
    CardName["APHRODITE_SHUTTLE_BASE"] = "Aphrodite Shuttle Base";
    CardName["ISHTAR_ENERGY_NETWORK"] = "Ishtar Energy Network";
    CardName["NEW_BABYLON"] = "New Babylon";
    // Industries (fan expansion)
    CardName["HEAT_INDUSTRY_STANDARD_PROJECT"] = "Heat Industry";
    CardName["MONEY_INDUSTRY_STANDARD_PROJECT"] = "Money Industry";
    CardName["ENERGY_INDUSTRY_STANDARD_PROJECT"] = "Energy Industry";
    CardName["STEEL_INDUSTRY_STANDARD_PROJECT"] = "Steel Industry";
    CardName["PLANT_INDUSTRY_STANDARD_PROJECT"] = "Plant Industry";
    CardName["TITANIUM_INDUSTRY_STANDARD_PROJECT"] = "Titanium Industry";
    CardName["WILD_INDUSTRY_STANDARD_PROJECT"] = "Wild Industry";
    // High Orbit (fan)
    CardName["SPACE_TRADING_STATION"] = "Space Trading Station";
    CardName["ORBITAL_HEADQUARTERS"] = "Orbital Headquarters";
    CardName["OBSERVATORY"] = "Observatory";
    CardName["PROPELLANT_DEPOT"] = "Propellant Depot";
    CardName["AUTO_FACTORY"] = "Auto Factory";
    CardName["ASTEROID_MINE"] = "Asteroid Mine";
    CardName["FREIGHTER"] = "Freighter";
    CardName["ORBITAL_SHIPYARD"] = "Orbital Shipyard";
    CardName["NAVIGATIONAL_BEACON"] = "Navigational Beacon";
    // High Orbit (fan)
    CardName["COMSAT"] = "Comsat";
    CardName["WEATHER_SATELLITE"] = "Weather Satellite";
    CardName["HYDROPONICS"] = "Hydroponics";
    CardName["SALVAGE_DEPOT"] = "Salvage Depot";
    CardName["POWERSAT"] = "Powersat";
    CardName["PLANETARY_OUTPOST"] = "Planetary Outpost";
    CardName["SPACE_HABITAT"] = "Space Habitat";
    CardName["SCIENCE_FACILITY"] = "Science Facility";
    CardName["PROBE"] = "Probe";
    // Solaris (fan)
    CardName["SIDERALIS"] = "Sideralis";
    CardName["STELLATRON"] = "Stellatron";
    CardName["BIONIC_AUGMENTATIONS"] = "Bionic Augmentations";
    CardName["SYNTHETIC_BRAIN_CELLS"] = "Synthetic Brain Cells";
    CardName["BUILDING_DEREGULATION"] = "Building Deregulation";
    CardName["POWER_LINES_HUB"] = "Power Lines Hub";
    CardName["CONDENSATION_PLANT"] = "Condensation Plant";
    CardName["WASTE_INCINERATOR"] = "Waste Incinerator";
    CardName["PLEBISCITE"] = "Plebiscite";
    CardName["STELLAR_ENGINE"] = "Stellar Engine";
    CardName["MARTIAN_CENSUS"] = "Martian Census";
    CardName["COMPANY_NATIONALIZATION"] = "Company Nationalization";
    CardName["TERRAIN_LEASE"] = "Terrain Lease";
    CardName["SYNERGISTIC_FORESTS"] = "Synergistic Forests";
    CardName["WANDERING_STATION_HERMES"] = "Wandering Station Hermes";
    CardName["FIRST_MAN_MONUMENT"] = "First Man Monument";
    CardName["AWARD_CELEBRATION"] = "Award Celebration";
    CardName["BRIBERY"] = "Bribery";
    CardName["MARS_ACADEMY_OF_POLITICAL_SCIENCES"] = "Mars Academy of Political Sciences";
    CardName["IMMIGRATION_BUREAU"] = "Immigration Bureau";
    CardName["ANTI_FRAUD_INVESTIGATION"] = "Anti Fraud Investigation";
    CardName["ACE_VETERAN_SQUAD"] = "Ace Veteran Squad";
    CardName["GALAXY_DEFENDERS"] = "Galaxy Defenders";
    CardName["MOTHERSHIP"] = "Mothership";
    CardName["HYPERSONIC_FIGHTERS"] = "Hypersonic Fighters";
    CardName["SHIELDING_DRONES"] = "Shielding Drones";
    // Solaris (fan) -- Galactic-tag batch
    CardName["SELF_REPLICATING_ROBOTS_SOLARIS"] = "Self-Replicating Robots (Solaris)";
    CardName["ATMOSPHERIC_COMPRESSOR"] = "Atmospheric Compressor";
    CardName["ORBITAL_HYDROGEOLOGIC_CANNON"] = "Orbital Hydrogeologic Cannon";
    CardName["EXTRAPLANETARY_URBANIZATOR"] = "Extraplanetary Urbanizator";
    CardName["EINSTEIN_ROSEN_GATEWAY"] = "Einstein-Rosen Gateway";
    CardName["PLANETARY_CORE_INDUCTOR"] = "Planetary Core Inductor";
    CardName["SYNTHETIC_GARGANTUA_TREES"] = "Synthetic Gargantua Trees";
    CardName["ARTIFICIAL_MOON"] = "Artificial Moon";
    CardName["SPACE_TELESCOPE"] = "Space Telescope";
    CardName["FLAGSHIP"] = "Flagship";
    // Solaris (fan) -- Turmoil party batch
    CardName["REDISTRIBUTION_OF_WEALTH"] = "Redistribution of Wealth";
    CardName["CYBORGS"] = "Cyborgs";
    CardName["STRONG_ARTIFICIAL_INTELLIGENCE"] = "Strong Artificial Intelligence";
    CardName["COLD_FUSION_TECHNOLOGY"] = "Cold Fusion Technology";
    CardName["GIANT_INDUSTRIAL_COMPLEX"] = "Giant Industrial Complex";
    CardName["MARTIAN_AGRICULTURE"] = "Martian Agriculture";
    CardName["TRADE_AGREEMENTS"] = "Trade Agreements";
    CardName["WISH_MACHINE"] = "Wish Machine";
    CardName["MANAGEMENT_CRISIS"] = "Management Crisis";
    CardName["ENERGY_ACQUISITION"] = "Energy Acquisition";
})(CardName || (CardName = {}));
